webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(298);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(302);
	
	var _angularTouch = __webpack_require__(303);
	
	var _angularTouch2 = _interopRequireDefault(_angularTouch);
	
	var _angularAnimate = __webpack_require__(305);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularSanitize = __webpack_require__(307);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _ngmap = __webpack_require__(309);
	
	var _ngmap2 = _interopRequireDefault(_ngmap);
	
	var _ngRollbar = __webpack_require__(310);
	
	var _ngRollbar2 = _interopRequireDefault(_ngRollbar);
	
	var _angularLocalStorage = __webpack_require__(312);
	
	var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);
	
	var _common = __webpack_require__(314);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(375);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _services = __webpack_require__(614);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _app = __webpack_require__(658);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _filters = __webpack_require__(664);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _directives = __webpack_require__(666);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	__webpack_require__(671);
	
	__webpack_require__(673);
	
	var _angularUiBootstrap = __webpack_require__(678);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	__webpack_require__(680);
	
	__webpack_require__(688);
	
	var _angularGoogleAnalytics = __webpack_require__(689);
	
	var _angularGoogleAnalytics2 = _interopRequireDefault(_angularGoogleAnalytics);
	
	__webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// font awesome css and directive
	_angular2.default.module('app', [_angularUiRouter2.default, _angularTouch2.default, _angularAnimate2.default, _angularSanitize2.default, _ngmap2.default, _ngRollbar2.default, _angularLocalStorage2.default, _common2.default, _components2.default, _angularUiBootstrap2.default, _services2.default, _filters2.default, _directives2.default, 'picardy.fontawesome', _angularGoogleAnalytics2.default, 'ui.router.title']).config(["$locationProvider", function ($locationProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	}]).config(["localStorageServiceProvider", function (localStorageServiceProvider) {
	  'ngInject';
	
	  localStorageServiceProvider.setPrefix('fmConnect').setNotify(true, true);
	}]).config(["RollbarProvider", function (RollbarProvider) {
	  'ngInject';
	  // ROLLBAR_TOKEN and ROLLBAR_ENV coming from webpack config
	
	  RollbarProvider.init({
	    accessToken: ("92a0da27b28b4cada8ad2e955a5b0aa9"),
	    captureUncaught: true,
	    payload: {
	      environment: ("production"),
	      client: {
	        javascript: {
	          source_map_enabled: true,
	          guess_uncaught_frames: true,
	          code_version: ("6bcf0e3c30911dd08ebbd006856fceb6d3cb16e9")
	        }
	      }
	    }
	  });
	}]).config(["AnalyticsProvider", function (AnalyticsProvider) {
	  'ngInject';
	  // Configure google analytics tracking
	
	  AnalyticsProvider.setAccount('UA-92796226-1').enterDebugMode(("production") == 'development').trackUrlParams(true).ignoreFirstPageLoad(true); // Helpful when using hashes and whenever your bounce rate looks obscenely low.
	}]).run(["$location", "$transitions", "Analytics", function ($location, $transitions, Analytics) {
	  'ngInject';
	  // Track page views when there is a transaction
	
	  $transitions.onSuccess({}, function (t) {
	    // Use updated page title when transition is fully resolved
	    t.promise.finally(function () {
	      return Analytics.trackPage($location.path(), document.title);
	    });
	  });
	}]).constant('MapsApiKey', 'AIzaSyCNhDhVd7JYPOaTzMma-dEYba9CjO_NHyk').component('app', _app2.default);

/***/ },
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbar = __webpack_require__(315);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _hero = __webpack_require__(366);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _user = __webpack_require__(373);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_navbar2.default, _hero2.default, _user2.default]).name;
	
	exports.default = commonModule;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(316);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarModule = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).name;
	
	exports.default = navbarModule;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(317);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(318);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _navbar2.default,
	  controller: _navbar4.default
	};
	
	exports.default = navbarComponent;

/***/ },
/* 317 */
/***/ function(module, exports) {

	module.exports = "<!-- Tablet navbar -->\n<nav class=\"navbar navbar-default navbar-fixed-top hidden-xs tablet-nav\">\n    <!-- Brand and toggle get grouped for better mobile display -->\n    <div class=\"navbar-header\">\n        <span class=\"navbar-brand\"></span>\n    </div>\n\n    <div class=\"container-fluid\">\n        <!-- Collect the nav links, forms, and other content for toggling -->\n        <div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\">\n            <ul class=\"nav navbar-nav\">\n                <li ui-sref-active=\"active\">\n                    <a ui-sref=\"news\">News</a>\n                </li>\n                <li ui-sref-active=\"active\">\n                    <a ui-sref=\"events\">Eventi</a>\n                </li>\n                <li ui-sref-active=\"active\">\n                    <a ui-sref=\"apps\">APPS</a>\n                </li>\n                <li ui-sref-active=\"active\">\n                    <a ui-sref=\"offices\">Sedi</a>\n                </li>\n            </ul>\n            <!-- Access button is on the right -->\n            <ul class=\"nav navbar-nav navbar-right\">\n                <li ui-sref-active=\"active\">\n                    <a ui-sref=\"settings\">\n                        <fm-username></fm-username>\n                        <fa name=\"cog\"></fa>\n                    </a>\n\n                </li>\n            </ul>\n        </div><!-- /.navbar-collapse -->\n    </div><!-- /.container-fluid -->\n</nav>\n\n<!-- Phone navbar -->\n<nav class=\"navbar navbar-default navbar-fixed-top visible-xs phone-nav\" ng-if=\"$ctrl.showMobileNavbar()\">\n    <!-- Brand and toggle get grouped for better mobile display -->\n    <div class=\"navbar-header\">\n        <h2 class=\"current-screen\">\n            <a ng-click=\"$ctrl.goToParentState()\" class=\"back-icon\">\n                <fa name=\"arrow-circle-o-left\" size=\"1\"></fa>\n            </a>\n            <span class=\"screen-name\" ng-class=\"$ctrl.screenNameClass()\">\n                {{$ctrl.screenName()}}\n            </span>\n        </h2>\n    </div>\n</nav>"

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _kebabCase2 = __webpack_require__(339);
	
	var _kebabCase3 = _interopRequireDefault(_kebabCase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function () {
	  NavbarController.$inject = ["$state", "$scope"];
	  function NavbarController($state, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NavbarController);
	    $scope.$state = $state;
	    this.$state = $state;
	    this.navigationLabels = {
	      news: 'News',
	      'news.item': 'News',
	      events: 'Eventi',
	      'events.event': 'Eventi',
	      apps: 'APPs',
	      offices: 'Sedi Territoriali',
	      'offices.office': 'Sedi Territoriali',
	      settings: 'Impostazioni',
	      'apps.digitalAgenda': 'Agenda Digitale',
	      'apps.digitalAgenda.show': 'Agenda Digitale',
	      'apps.projectManager': 'Progetto Manager',
	      'apps.projectManager.list': 'Progetto Manager',
	      'apps.projectManager.list.show': 'Progetto Manager',
	      'apps.youtube': 'Youtube',
	      'apps.youtube.show': 'Youtube'
	    };
	  }
	
	  (0, _createClass3.default)(NavbarController, [{
	    key: 'goToParentState',
	    value: function goToParentState() {
	      var nextState = this.$state.$current.parent && !this.$state.$current.parent.abstract ? this.$state.$current.parent.name : 'home';
	      console.debug('Current State', this.$state.current.name, 'going to', nextState);
	      this.$state.go(nextState);
	    }
	  }, {
	    key: 'showMobileNavbar',
	    value: function showMobileNavbar() {
	      return this.$state.current.name != 'home';
	    }
	  }, {
	    key: 'screenName',
	    value: function screenName() {
	      return this.navigationLabels[this.$state.current.name] || this.$state.current.name;
	    }
	  }, {
	    key: 'screenNameClass',
	    value: function screenNameClass() {
	      return (0, _kebabCase3.default)(this.screenName());
	    }
	  }]);
	  return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ },
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(362);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./navbar.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./navbar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".tablet-nav.navbar-default .navbar-header{padding:1rem;margin-left:2rem}.tablet-nav.navbar-default .navbar-header .navbar-brand{background:url(" + __webpack_require__(364) + ") no-repeat 50%;background-size:100%;width:60px;height:60px;padding:0}.tablet-nav.navbar-default .navbar-nav>li.active>a{color:#f5f5f5}.tablet-nav.navbar-default .navbar-nav>li>a{font-size:25px;padding-top:30px;padding-bottom:20px;font-family:Lato-Light,sans-serif}.tablet-nav.navbar-default .navbar-nav>li>a:hover{color:inherit}.tablet-nav.navbar-default a[ui-sref]{text-transform:uppercase}.phone-nav{background-color:rgba(37,40,47,.7)!important}.phone-nav .current-screen{margin-top:10px;display:flex;justify-content:space-between;align-items:center;position:relative}.phone-nav .current-screen .back-icon{margin-left:15px;color:#f5f5f5}.phone-nav .current-screen .screen-name{display:block;position:absolute;left:50%;transform:translate(-50%);font-size:25px;font-family:Lato-Light,sans-serif;color:#00d5c3}.phone-nav .current-screen .screen-name.progetto-manager{font-size:20px}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/common/client/app/common/navbar/navbar.scss","/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/common/client/app/bootstrap-customizations.scss"],"names":[],"mappings":"AAGA,0CAII,aACA,gBAAiB,CALrB,wDAQM,uDACA,qBACA,WACA,YACA,SAAU,CAZhB,mDAkBI,aCjBgB,CDDpB,4CAsBI,eACA,iBACA,oBCyBF,iCAAqC,CDjDvC,kDA2BM,aAAc,CA3BpB,sCAgCI,wBAAyB,CAC1B,WAID,4CAAgD,CADlD,2BAII,gBACA,aACA,8BACA,mBACA,iBAAkB,CARtB,sCAWM,iBACA,aC/Cc,CDmCpB,wCAgBM,cACA,kBAEA,SACA,0BCHJ,eAJA,kCAMA,aAhDe,CD6BjB,yDAyBQ,cAAe,CAChB","file":"navbar.scss","sourcesContent":["@import '../common';\n@import '../../bootstrap-customizations';\n\n.tablet-nav.navbar-default {\n\n  .navbar-header {\n\n    padding: 1rem;\n    margin-left: 2rem;\n\n    .navbar-brand {\n      background: url(../../img/logo-topbar@2x.png) no-repeat center center;\n      background-size: 100%;\n      width: 60px;\n      height: 60px;\n      padding: 0;\n    }\n  }\n\n  // reset styles for hover and links\n  .navbar-nav > li.active > a {\n    color: $whitesmoke;\n  }\n\n  .navbar-nav > li > a {\n    font-size: 25px;\n    padding-top: 30px;\n    padding-bottom: 20px;\n    @include lightFont();\n    &:hover {\n      color: inherit;\n    }\n  }\n\n  a[ui-sref] {\n    text-transform: uppercase;\n  }\n}\n\n.phone-nav {\n  background-color: $appTransparentBlue !important;\n\n  .current-screen {\n    margin-top: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n\n    .back-icon {\n      margin-left: 15px;\n      color: $whitesmoke;\n    }\n\n    .screen-name {\n      display: block;\n      position: absolute;\n      // center into parent container\n      left: 50%;\n      transform: translate(-50%, 0);\n\n      @include normalH2();\n\n      &.progetto-manager {\n        font-size: 20px;\n      }\n    }\n  }\n}\n","//noinspection CssUnknownTarget\n@import url(//fonts.googleapis.com/css?family=Lato);\n\n// default color for texts\n$whitesmoke: #f5f5f5;\n\n// APP colors\n$appGrey: #B7B7B7;\n$appDarkBlue: #21242A;\n$appTransparentBlue: rgba(37, 40, 47, 0.7);\n$appAqua: #00D5C3;\n\n// Customize Bootstrap variables that get imported before the original Bootstrap variables.\n// Thus original Bootstrap variables can depend on values from here.\n$brand-primary: $appAqua;\n\n// customize app fonts and size\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n\n//** Global text color on `<body>`.\n$text-color: $whitesmoke !default;\n\n//== Typography\n//\n//## Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n$font-family-serif: Georgia, \"Times New Roman\", Times, serif !default;\n//** Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`.\n$font-family-monospace: Menlo, Monaco, Consolas, \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 14px !default;\n$font-size-large: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-small: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n$font-size-h1: floor(($font-size-base * 2.6)) !default; // ~36px\n$font-size-h2: floor(($font-size-base * 2.15)) !default; // ~30px\n$font-size-h3: ceil(($font-size-base * 1.7)) !default; // ~24px\n$font-size-h4: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-h5: $font-size-base !default;\n$font-size-h6: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n// Remove navbar backgrounds and colors\n$navbar-default-color: transparent !default;\n$navbar-default-bg: transparent !default;\n\n@mixin normalFont {\n  font-family: 'Lato', sans-serif;\n}\n\n@mixin lightFont {\n  font-family: 'Lato-Light', sans-serif;\n}\n\n@mixin normalH2 {\n  font-size: 25px;\n  @include lightFont();\n  color: $appAqua;\n}\n\n//Alloy.Globals.Typo = {\n//\th1: { fontSize: 40, fontFamily:'Lato-Light' },\n//\th1bold: { fontSize: 40, fontFamily:'Lato-Bold' },\n//\th2: { fontSize: 25, fontFamily:'Lato-Light' },\n//\th2bold: { fontSize: 25, fontFamily:'Lato-Bold' },\n//\th3: { fontSize: 18, fontFamily:'Lato-Light' },\n//\th3bold: { fontSize: 18, fontFamily:'Lato-Bold' },\n//\th4: { fontSize: 15, fontFamily:'Lato-Regular' },\n//\th4bold: { fontSize: 15, fontFamily:'Lato-Bold' },\n//\th5: { fontSize: 13, fontFamily:'Lato-Regular' },\n//\th5bold: { fontSize: 13, fontFamily:'Lato-Bold' }\n//};\n\n// navbar heights\n$tablet-navbar-height: 82px;\n$mobile-navbar-height: 55px;\n\n// Include this mixin to make an element scrollable within body and to take full body height\n@mixin fullBody {\n\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 363 */,
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "logo-topbar@2x-47cfca95e3be6af4ce6260edc528ca7e.png";

/***/ },
/* 365 */,
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _hero = __webpack_require__(367);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var heroModule = _angular2.default.module('hero', [_angularUiRouter2.default]).component('hero', _hero2.default).name;
	
	exports.default = heroModule;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hero = __webpack_require__(368);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _hero3 = __webpack_require__(369);
	
	var _hero4 = _interopRequireDefault(_hero3);
	
	__webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var heroComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _hero2.default,
	  controller: _hero4.default
	};
	
	exports.default = heroComponent;

/***/ },
/* 368 */
/***/ function(module, exports) {

	module.exports = "<section class=\"hero\">\n</section>\n"

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroController = function HeroController() {
	  (0, _classCallCheck3.default)(this, HeroController);
	
	  this.name = 'hero';
	};
	
	exports.default = HeroController;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(371);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./hero.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./hero.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".hero{height:30rem;padding:3rem;background:url(" + __webpack_require__(372) + ") no-repeat;background-position-y:25%;background-position-x:center;background-size:85%}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/common/client/app/common/hero/hero.scss"],"names":[],"mappings":"AAGA,MACE,aACA,aAEA,mDACA,0BACA,6BACA,mBAAoB,CACrB","file":"hero.scss","sourcesContent":["@import '../common';\n@import '../../bootstrap-customizations';\n\n.hero {\n  height: 30rem;\n  padding: 3rem;\n\n  background: url(../../img/iphone-home@2x.png) no-repeat;\n  background-position-y: 25%;\n  background-position-x: center;\n  background-size: 85%;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "iphone-home@2x-684a24109a5f52026c37448dabbe45c3.png";

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(374);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module('user', []).factory('User', _user2.default).name;
	
	exports.default = userModule;

/***/ },
/* 374 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UserFactory = function UserFactory() {
	  var user = {};
	
	  var getUser = function getUser() {
	    return user;
	  };
	
	  var isSignedIn = function isSignedIn() {
	    return user.isSignedIn;
	  };
	
	  return { getUser: getUser, isSignedIn: isSignedIn };
	};
	
	exports.default = UserFactory;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(376);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _news = __webpack_require__(382);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _events = __webpack_require__(421);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _apps = __webpack_require__(543);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _offices = __webpack_require__(588);
	
	var _offices2 = _interopRequireDefault(_offices);
	
	var _settings = __webpack_require__(600);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _loaderScreen = __webpack_require__(606);
	
	var _loaderScreen2 = _interopRequireDefault(_loaderScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_home2.default, _news2.default, _events2.default, _apps2.default, _offices2.default, _settings2.default, _loaderScreen2.default]).run(["$transitions", function ($transitions) {
	  'ngInject';
	  // reset scroll state of main view when a transition is completed
	
	  $transitions.onSuccess({}, function () {
	    document.getElementById('main-view').scrollTop = 0;
	  });
	}]).name;
	
	exports.default = componentModule;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _home = __webpack_require__(377);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module('home', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('home', {
	    url: '/',
	    component: 'home',
	    resolve: {
	      $title: function $title() {
	        return 'FM Connect - Home';
	      }
	    }
	  });
	}]).component('home', _home2.default).name;
	
	exports.default = homeModule;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _home = __webpack_require__(378);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(379);
	
	var _home4 = _interopRequireDefault(_home3);
	
	__webpack_require__(380);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _home2.default,
	  controller: _home4.default
	};
	
	exports.default = homeComponent;

/***/ },
/* 378 */
/***/ function(module, exports) {

	module.exports = "<header>\n  <hero></hero>\n</header>\n<p style=\"text-align: center\">Le sezioni News ed Eventi sono momentaneamente in manutenzione.</p>\n<main>\n    <div class=\"home-buttons\">\n        <!-- Navigation links for xs devices -->\n        <button type=\"button\" ui-sref=\"#\" class=\"btn btn-default btn-lg btn-block\" style=\"color: gray\">News</button>\n        <button type=\"button\" ui-sref=\"#\" class=\"btn btn-default btn-lg btn-block\" style=\"color: gray\">Eventi</button>\n        <button type=\"button\" ui-sref=\"apps\" class=\"btn btn-default btn-lg btn-block\">APPs</button>\n        <button type=\"button\" ui-sref=\"offices\" class=\"btn btn-default btn-lg btn-block\">Sedi</button>\n        <button type=\"button\" ui-sref=\"settings\" class=\"btn btn-default btn-lg btn-block\">Impostazioni</button>\n    </div>\n</main>"

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeController = function HomeController($window, $state) {
	  'ngInject';
	  // directly go to news panel if not xs screen
	
	  (0, _classCallCheck3.default)(this, HomeController);
	  if ($window.innerWidth >= 768) {
	    $state.go('news');
	  }
	};
	HomeController.$inject = ["$window", "$state"];
	
	exports.default = HomeController;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(381);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./home.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".home-buttons button.btn-block.btn-default{width:90%;margin:2% 5%;background-color:transparent;color:#f5f5f5;font-family:Lato-Light,sans-serif}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/components/home/home.scss","/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/bootstrap-customizations.scss"],"names":[],"mappings":"AAEA,2CAEI,UACA,aAEA,6BACA,cC4CF,iCAAqC,CD1CpC","file":"home.scss","sourcesContent":["@import '../../bootstrap-customizations';\n\n.home-buttons {\n  button.btn-block.btn-default {\n    width: 90%;\n    margin: 2% 5%;\n\n    background-color: transparent;\n    color: $whitesmoke;\n    @include lightFont();\n  }\n}","//noinspection CssUnknownTarget\n@import url(//fonts.googleapis.com/css?family=Lato);\n\n// default color for texts\n$whitesmoke: #f5f5f5;\n\n// APP colors\n$appGrey: #B7B7B7;\n$appDarkBlue: #21242A;\n$appTransparentBlue: rgba(37, 40, 47, 0.7);\n$appAqua: #00D5C3;\n\n// Customize Bootstrap variables that get imported before the original Bootstrap variables.\n// Thus original Bootstrap variables can depend on values from here.\n$brand-primary: $appAqua;\n\n// customize app fonts and size\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n\n//** Global text color on `<body>`.\n$text-color: $whitesmoke !default;\n\n//== Typography\n//\n//## Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n$font-family-serif: Georgia, \"Times New Roman\", Times, serif !default;\n//** Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`.\n$font-family-monospace: Menlo, Monaco, Consolas, \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 14px !default;\n$font-size-large: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-small: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n$font-size-h1: floor(($font-size-base * 2.6)) !default; // ~36px\n$font-size-h2: floor(($font-size-base * 2.15)) !default; // ~30px\n$font-size-h3: ceil(($font-size-base * 1.7)) !default; // ~24px\n$font-size-h4: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-h5: $font-size-base !default;\n$font-size-h6: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n// Remove navbar backgrounds and colors\n$navbar-default-color: transparent !default;\n$navbar-default-bg: transparent !default;\n\n@mixin normalFont {\n  font-family: 'Lato', sans-serif;\n}\n\n@mixin lightFont {\n  font-family: 'Lato-Light', sans-serif;\n}\n\n@mixin normalH2 {\n  font-size: 25px;\n  @include lightFont();\n  color: $appAqua;\n}\n\n//Alloy.Globals.Typo = {\n//\th1: { fontSize: 40, fontFamily:'Lato-Light' },\n//\th1bold: { fontSize: 40, fontFamily:'Lato-Bold' },\n//\th2: { fontSize: 25, fontFamily:'Lato-Light' },\n//\th2bold: { fontSize: 25, fontFamily:'Lato-Bold' },\n//\th3: { fontSize: 18, fontFamily:'Lato-Light' },\n//\th3bold: { fontSize: 18, fontFamily:'Lato-Bold' },\n//\th4: { fontSize: 15, fontFamily:'Lato-Regular' },\n//\th4bold: { fontSize: 15, fontFamily:'Lato-Bold' },\n//\th5: { fontSize: 13, fontFamily:'Lato-Regular' },\n//\th5bold: { fontSize: 13, fontFamily:'Lato-Bold' }\n//};\n\n// navbar heights\n$tablet-navbar-height: 82px;\n$mobile-navbar-height: 55px;\n\n// Include this mixin to make an element scrollable within body and to take full body height\n@mixin fullBody {\n\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _news = __webpack_require__(383);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _mainNewsItem = __webpack_require__(415);
	
	var _mainNewsItem2 = _interopRequireDefault(_mainNewsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newsModule = _angular2.default.module('news', [_angularUiRouter2.default, _mainNewsItem2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('news', {
	    url: '/news',
	    component: 'news',
	    resolve: {
	      $title: function $title() {
	        return 'News';
	      }
	    }
	  });
	}]).component('news', _news2.default).name;
	
	exports.default = newsModule;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _news = __webpack_require__(384);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _news3 = __webpack_require__(385);
	
	var _news4 = _interopRequireDefault(_news3);
	
	__webpack_require__(413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _news2.default,
	  controller: _news4.default
	};
	
	exports.default = newsComponent;

/***/ },
/* 384 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n\n        <!-- News viewer -->\n        <div class=\"col-sm-8 col-sm-push-4 news-body\">\n\n            <div ui-view></div>\n\n            <!-- Carousel shown until no news is selected -->\n            <div class=\"news-carousel\" ng-if=\"$ctrl.showCarousel()\">\n\n                <!-- Don't know why is not working right now -->\n                <div uib-carousel interval=\"3000\" active=\"active\">\n                    <div uib-slide ng-repeat=\"slide in $ctrl.carouselItems track by $index\" index=\"$index\"\n                         style=\"cursor: pointer;\" ng-click=\"$ctrl.openNews(slide.link)\">\n                        <img class=\"carousel-image\" ng-src=\"{{slide.featured_image}}\">\n                        <div class=\"carousel-caption\">\n                            <h4 ng-bind-html=\"slide.title.rendered\"></h4>\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Banner under carousel -->\n                <div class=\"news-banner hidden-xs\">\n                    <img class=\"img-responsive\" ng-src=\"{{$ctrl.bannerImage}}\">\n                </div>\n\n            </div>\n\n        </div>\n\n        <!-- News list -->\n        <div class=\"col-sm-4 col-sm-pull-8 news-list-sidebar\" ng-hide=\"$ctrl.hideNewsList()\">\n\n            <!-- Category selector -->\n            <uib-accordion close-others=\"oneAtATime\">\n                <div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.filterOpen\">\n                    <uib-accordion-heading>\n                        <span ng-bind-html=\"$ctrl.selectedCategory.label | uppercase\"></span>\n                        <fa name=\"{{$ctrl.filterOpen ? 'chevron-down' : 'chevron-right'}}\" class=\"pull-right\"></fa>\n                    </uib-accordion-heading>\n\n                    <ul class=\"list-unstyled category-list\">\n                        <li>\n                            <a ng-click=\"$ctrl.selectCategory({label: 'TUTTE LE SEDI', id: ''})\">\n                                TUTTE LE SEDI\n                            </a>\n                        </li>\n                        <hr>\n                        <li ng-repeat=\"category in $ctrl.categoryList track by category.id\">\n                            <a ng-click=\"$ctrl.selectCategory(category)\"\n                               ng-bind-html=\"category.label | uppercase\">\n                            </a>\n                        </li>\n                    </ul>\n                </div>\n            </uib-accordion>\n\n            <!-- News list -->\n            <ul class=\"dated-news-list list-unstyled\">\n                <li ng-repeat=\"(newsDate, newsList) in $ctrl.groupedNewsList track by newsDate\"\n                    ng-if=\"(newsList | filter:{id_sede: $ctrl.selectedCategory.id}).length\">\n                    <h4 class=\"news-date\">{{newsDate}}</h4>\n                    <div class=\"media\" ng-repeat=\"news in newsList | filter:{id_sede: $ctrl.selectedCategory.id}\">\n                        <div class=\"media-left\">\n                            <img class=\"media-object\" ng-src=\"{{news.img || $ctrl.fallbackImage}}\" fm-image-error>\n                        </div>\n                        <div class=\"media-body\">\n                            <h4 class=\"media-heading\" ng-click=\"$ctrl.selectNews(news)\" ng-bind-html=\"news.title\"></h4>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n            <!-- News placeholder for empty newslist  -->\n            <div ng-if=\"($ctrl.newsList | filter:{id_sede: $ctrl.selectedCategory.id}).length == 0\">\n                <p class=\"uppercase\">\n                    <fa name=\"frown-o\" size=\"2\"></fa>\n                    Non ci sono articoli per questa sede territoriale\n                </p>\n\n            </div>\n        </div>\n\n    </div>\n</div>\n"

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _externalLink = __webpack_require__(408);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsController = function () {
	  NewsController.$inject = ["NewsService", "OfficesService", "$window", "$state"];
	  function NewsController(NewsService, OfficesService, $window, $state) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, NewsController);
	    (0, _assign2.default)(this, { NewsService: NewsService, $window: $window, $state: $state });
	    // Load carousel items
	    NewsService.carousel().then(function (carousel) {
	      return _this.carouselItems = carousel;
	    });
	    // load news
	    NewsService.list().then(function (list) {
	      _this.newsList = list;
	      _this.groupedNewsList = (0, _lodash2.default)(list).groupBy('dataPubblicazione').value();
	    });
	    // load categories
	    OfficesService.list().then(function (list) {
	      return _this.categoryList = list;
	    });
	    // category is the name of the office, default is office with id 100
	    this.selectedCategory = { label: 'TUTTE LE SEDI', id: '' };
	    // banner image
	    this.bannerImage = __webpack_require__(411);
	    // true iff on tablet
	    this.bigScreen = $window.innerWidth >= 768;
	    // fallback image
	    this.fallbackImage = __webpack_require__(412);
	  }
	
	  (0, _createClass3.default)(NewsController, [{
	    key: 'selectNews',
	    value: function selectNews(news) {
	      console.debug('Going to news.item state', { officeId: news.id_sede, newsId: news.id_elemento });
	      this.$state.go('news.item', { officeId: news.id_sede, newsId: news.id_elemento });
	    }
	  }, {
	    key: 'selectCategory',
	    value: function selectCategory(category) {
	      this.selectedCategory = category;
	      this.filterOpen = false;
	    }
	  }, {
	    key: 'openNews',
	    value: function openNews(url) {
	      this.$window.open((0, _externalLink.prefixedExternalUrl)(url), '_blank');
	    }
	  }, {
	    key: 'showCarousel',
	    value: function showCarousel() {
	      return this.$state.current.name === 'news';
	    }
	  }, {
	    key: 'hideNewsList',
	    value: function hideNewsList() {
	      return !this.bigScreen && this.$state.current.name !== 'news';
	    }
	  }]);
	  return NewsController;
	}();
	
	exports.default = NewsController;

/***/ },
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	fmExternalLink.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.prefixedExternalUrl = prefixedExternalUrl;
	exports.default = fmExternalLink;
	/**
	 * Change external URLs if variable is defined when building
	 * @param url
	 */
	function prefixedExternalUrl(url) {
	  var finalUrl =  true ? ("webview://localhost/") + url : url;
	  // Debug url that will be opened
	  console.debug('URL', url, 'rewritten to', finalUrl);
	  return finalUrl;
	}
	
	/**
	 * Used as central point to open links in new tabs or new webviews
	 */
	function fmExternalLink($window) {
	  'ngInject';
	
	  return {
	    restrict: 'A',
	    priority: 0,
	    link: function link(scope, element, attrs) {
	      // Prevent default behavior and open links in a new tabs
	      element.bind('click', function (event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	        // ng-href priority is 99, so href should be present at this time
	        $window.open(prefixedExternalUrl(attrs.href), '_blank');
	      });
	    }
	  };
	}

/***/ },
/* 409 */,
/* 410 */,
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "banner-default@2x-514d3dd99acb8dfa4c12b6e0fda18600.jpg";

/***/ },
/* 412 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(414);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./news.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./news.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".news-list-sidebar img.media-object{width:50px}.news-list-sidebar .media-heading{text-transform:uppercase;cursor:pointer}.news-list-sidebar .category-list li a{cursor:pointer}.news-list-sidebar .dated-news-list .news-date{background-color:#f5f5f5;display:block;color:#383838;font-family:Lato,sans-serif;font-weight:700;padding-left:15px;padding-right:15px;margin-bottom:.5em}@media (min-width:768px){.news-body .news-carousel{margin-top:40px;height:305px}}@media (max-width:768px){.news-body .news-carousel{margin-bottom:20px}}.news-body .news-carousel .carousel-image{margin:auto;max-width:100%}.news-body .carousel-caption{background-color:rgba(0,0,0,.5)!important;left:0;right:0;bottom:0;padding-bottom:40px}@media (max-width:768px){.news-body .carousel-caption{bottom:auto!important;top:0;padding-bottom:20px}}.news-body .news-banner{margin-top:40px;text-align:center}.news-body .news-banner img{display:block;margin:0 auto;width:520px}.news-body .glyphicon{display:inline-block;font-family:FontAwesome;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.news-body .glyphicon-chevron-left:before{content:\"\\F053\"}.news-body .glyphicon-chevron-right:before{content:\"\\F054\"}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/components/news/news.scss","/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/bootstrap-customizations.scss"],"names":[],"mappings":"AAGA,oCAGI,UAAW,CAHf,kCAOI,yBACA,cAAe,CARnB,uCAaM,cAAe,CAbrB,+CAmBM,yBACA,cACA,cCwBJ,4BDtBI,gBACA,kBACA,mBACA,kBAAoB,CACrB,yBAIL,0BAIM,gBACA,YAAa,CAahB,CAXC,yBAPJ,0BASM,kBAAmB,CAStB,CAlBH,0CAcM,YACA,cAAe,CAfrB,6BAqBI,0CACA,OACA,QACA,SACA,mBAAoB,CAEpB,yBA3BJ,6BA4BM,sBACA,MACA,mBAAoB,CAEvB,CAhCH,wBAmCI,gBACA,iBAAkB,CApCtB,4BAsCM,cACA,cACA,WAAY,CAxClB,sBA6CI,qBACA,wBACA,kBACA,gBACA,cACA,mCACA,iCAAkC,CAnDtC,0CAsDI,eAAgB,CAtDpB,2CAyDI,eAAgB,CACjB","file":"news.scss","sourcesContent":["@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss\";\n@import '../../bootstrap-customizations';\n\n.news-list-sidebar {\n\n  img.media-object {\n    width: 50px;\n  }\n\n  .media-heading {\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n\n  .category-list {\n    li a {\n      cursor: pointer;\n    }\n  }\n\n  .dated-news-list {\n    .news-date {\n      background-color: $whitesmoke;\n      display: block;\n      color: darken($appGrey, 50%);\n      @include normalFont();\n      font-weight: bold;\n      padding-left: 15px;\n      padding-right: 15px;\n      margin-bottom: 0.5em;\n    }\n  }\n}\n\n.news-body {\n  .news-carousel {\n    @media (min-width: $screen-sm-min) {\n      // add margin only on tablet\n      margin-top: 40px;\n      height: 305px;\n    }\n    @media (max-width: $screen-sm-min) {\n      // add margin only on tablet\n      margin-bottom: 20px;\n    }\n\n    // images\n    .carousel-image {\n      margin: auto;\n      max-width: 100%;\n    }\n\n  }\n\n  .carousel-caption {\n    background-color: rgba(0, 0, 0, 0.5) !important;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding-bottom: 40px;\n\n    @media (max-width: $screen-sm-min) {\n      bottom: auto !important;\n      top: 0;\n      padding-bottom: 20px;\n    }\n  }\n\n  .news-banner {\n    margin-top: 40px;\n    text-align: center;\n    img {\n      display: block;\n      margin: 0 auto;\n      width: 520px;\n    }\n  }\n\n  .glyphicon {\n    display: inline-block;\n    font-family: FontAwesome;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  .glyphicon-chevron-left:before {\n    content: \"\\f053\";\n  }\n  .glyphicon-chevron-right:before {\n    content: \"\\f054\";\n  }\n}","//noinspection CssUnknownTarget\n@import url(//fonts.googleapis.com/css?family=Lato);\n\n// default color for texts\n$whitesmoke: #f5f5f5;\n\n// APP colors\n$appGrey: #B7B7B7;\n$appDarkBlue: #21242A;\n$appTransparentBlue: rgba(37, 40, 47, 0.7);\n$appAqua: #00D5C3;\n\n// Customize Bootstrap variables that get imported before the original Bootstrap variables.\n// Thus original Bootstrap variables can depend on values from here.\n$brand-primary: $appAqua;\n\n// customize app fonts and size\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n\n//** Global text color on `<body>`.\n$text-color: $whitesmoke !default;\n\n//== Typography\n//\n//## Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n$font-family-serif: Georgia, \"Times New Roman\", Times, serif !default;\n//** Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`.\n$font-family-monospace: Menlo, Monaco, Consolas, \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 14px !default;\n$font-size-large: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-small: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n$font-size-h1: floor(($font-size-base * 2.6)) !default; // ~36px\n$font-size-h2: floor(($font-size-base * 2.15)) !default; // ~30px\n$font-size-h3: ceil(($font-size-base * 1.7)) !default; // ~24px\n$font-size-h4: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-h5: $font-size-base !default;\n$font-size-h6: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n// Remove navbar backgrounds and colors\n$navbar-default-color: transparent !default;\n$navbar-default-bg: transparent !default;\n\n@mixin normalFont {\n  font-family: 'Lato', sans-serif;\n}\n\n@mixin lightFont {\n  font-family: 'Lato-Light', sans-serif;\n}\n\n@mixin normalH2 {\n  font-size: 25px;\n  @include lightFont();\n  color: $appAqua;\n}\n\n//Alloy.Globals.Typo = {\n//\th1: { fontSize: 40, fontFamily:'Lato-Light' },\n//\th1bold: { fontSize: 40, fontFamily:'Lato-Bold' },\n//\th2: { fontSize: 25, fontFamily:'Lato-Light' },\n//\th2bold: { fontSize: 25, fontFamily:'Lato-Bold' },\n//\th3: { fontSize: 18, fontFamily:'Lato-Light' },\n//\th3bold: { fontSize: 18, fontFamily:'Lato-Bold' },\n//\th4: { fontSize: 15, fontFamily:'Lato-Regular' },\n//\th4bold: { fontSize: 15, fontFamily:'Lato-Bold' },\n//\th5: { fontSize: 13, fontFamily:'Lato-Regular' },\n//\th5bold: { fontSize: 13, fontFamily:'Lato-Bold' }\n//};\n\n// navbar heights\n$tablet-navbar-height: 82px;\n$mobile-navbar-height: 55px;\n\n// Include this mixin to make an element scrollable within body and to take full body height\n@mixin fullBody {\n\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mainNewsItem = __webpack_require__(416);
	
	var _mainNewsItem2 = _interopRequireDefault(_mainNewsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainNewsItemModule = _angular2.default.module('mainNewsItem', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('news.item', {
	    url: '/:officeId/:newsId',
	    component: 'mainNewsItem',
	    resolve: {
	      selectedNews: ["NewsService", "$stateParams", function selectedNews(NewsService, $stateParams) {
	        return NewsService.fullNews($stateParams.newsId, $stateParams.officeId);
	      }],
	      $title: ["selectedNews", function $title(selectedNews) {
	        return 'News - ' + selectedNews.title;
	      }]
	    }
	  });
	}]).component('mainNewsItem', _mainNewsItem2.default).name;
	
	exports.default = mainNewsItemModule;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mainNewsItem = __webpack_require__(417);
	
	var _mainNewsItem2 = _interopRequireDefault(_mainNewsItem);
	
	var _mainNewsItem3 = __webpack_require__(418);
	
	var _mainNewsItem4 = _interopRequireDefault(_mainNewsItem3);
	
	__webpack_require__(419);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainNewsItemComponent = {
	  restrict: 'E',
	  bindings: { selectedNews: '<' },
	  template: _mainNewsItem2.default,
	  controller: _mainNewsItem4.default
	};
	
	exports.default = mainNewsItemComponent;

/***/ },
/* 417 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <h3>{{$ctrl.selectedNews.categoria}}</h3>\n    <h1 ng-bind-html=\"$ctrl.selectedNews.title\"></h1>\n    <h4>\n        {{$ctrl.selectedNews.data}}\n        <small class=\"pull-right\">\n            <a class=\"btn btn-default btn-primary\"\n               ng-hide=\"$ctrl.selectedNews.url.indexOf('elencoNewsSede.do') > -1\"\n               ng-href=\"{{$ctrl.selectedNews.url}}\" fm-external-link>Apri</a>\n        </small>\n    </h4>\n    <p ng-if=\"$ctrl.selectedNews.content\" ng-bind-html=\"$ctrl.selectedNews.content\"></p>\n</div>\n"

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _externalLink = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainNewsItemController = function MainNewsItemController($window) {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, MainNewsItemController);
	  if (!this.selectedNews.content) {
	    $window.open((0, _externalLink.prefixedExternalUrl)(this.selectedNews.url), '_blank');
	  }
	};
	MainNewsItemController.$inject = ["$window"];
	
	exports.default = MainNewsItemController;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(420);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./mainNewsItem.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./mainNewsItem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	
	
	// module
	exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"mainNewsItem.scss","sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _events = __webpack_require__(422);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _event = __webpack_require__(537);
	
	var _event2 = _interopRequireDefault(_event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventsModule = _angular2.default.module('events', [_angularUiRouter2.default, _event2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('events', {
	    url: '/events',
	    component: 'events',
	    resolve: {
	      $title: function $title() {
	        return 'Eventi';
	      }
	    }
	  });
	}]).component('events', _events2.default).name;
	
	exports.default = eventsModule;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(423);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _events3 = __webpack_require__(424);
	
	var _events4 = _interopRequireDefault(_events3);
	
	__webpack_require__(535);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _events2.default,
	  controller: _events4.default
	};
	
	exports.default = eventsComponent;

/***/ },
/* 423 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n\n        <!-- Event list with calendar -->\n        <div class=\"col-sm-4 event-list-sidebar hidden-xs\">\n            <!-- Calendar -->\n            <div class=\"text-center hidden-xs\">\n                <div uib-datepicker class=\"events-date-picker\"\n                     ng-model=\"$ctrl.selectedDay\" datepicker-options=\"$ctrl.calendarOptions\">\n                </div>\n            </div>\n            <!-- Event list -->\n            <div class=\"event-list\">\n                <h2 class=\"text-center hidden-xs\">\n                    {{$ctrl.selectedDay | date:'dd/MM/yyyy'}}\n                </h2>\n\n                <p ng-if=\"!$ctrl.hasEvents($ctrl.selectedDay)\">\n                    Non ci sono eventi per questo giorno\n                </p>\n\n                <ul class=\"event-list-events hidden-xs list-unstyled\" ng-if=\"$ctrl.hasEvents($ctrl.selectedDay)\">\n                    <li class=\"event-item\"\n                        ng-repeat=\"office_id in $ctrl.getOfficesFor($ctrl.selectedDay) track by office_id\">\n\n                        <span class=\"date-or-office\">{{$ctrl.officeName(office_id) | officeName:true}}</span>\n\n                        <ul class=\"list-unstyled\">\n                            <li class=\"row\"\n                                ng-click=\"$ctrl.selectEvent(event)\"\n                                ng-repeat=\"event in $ctrl.getEventsFor($ctrl.selectedDay, office_id) track by event.id_elemento\">\n\n                                <p class=\"col-xs-2 hours\" ng-if=\"!$ctrl.ifFullDay(event)\">\n                                    {{$ctrl.eventTime(event)}}\n                                </p>\n                                <a class=\"col-xs-{{$ctrl.ifFullDay(event) ? '12' : '10'}}\">\n                                    <span class=\"event-title\">\n                                        {{event.title}}\n                                    </span>\n                                </a>\n                            </li>\n                        </ul>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <!-- Nested view for selected event -->\n        <ui-view>\n            <div class=\"row\">\n                <ul class=\"event-list-phones list-unstyled visible-xs\">\n                    <li class=\"past-event-toggler\">\n                        <p>\n                            <span>{{$ctrl.showPastEvents ? 'Nascondi eventi passati' : 'Mostra eventi passati' }}</span>\n                            <fa ng-click=\"$ctrl.togglePastEvents()\" size=\"2\"\n                                name=\"{{$ctrl.showPastEvents ? 'eye' : 'eye-slash' }}\"></fa>\n                        </p>\n                    </li>\n\n                    <li class=\"event-item\" ng-repeat=\"(date, events) in $ctrl.events track by date\" ng-show=\"$ctrl.isDateShown(date)\">\n                        <span class=\"date-or-office\">{{date | date:'dd/MM/yyyy'}}</span>\n\n                        <ul class=\"events-for-date list-unstyled\">\n                            <li class=\"row\"\n                                ng-click=\"$ctrl.selectEvent(event)\"\n                                ng-repeat=\"event in events track by event.id_elemento\">\n                                <p class=\"col-xs-2 hours\" ng-if=\"!$ctrl.ifFullDay(event)\">\n                                    {{$ctrl.eventTime(event)}}\n                                </p>\n                                <a class=\"col-xs-{{$ctrl.ifFullDay(event) ? '12' : '10'}}\">\n                                        <span class=\"event-office\">\n                                            {{$ctrl.officeName(event.id_sede) | officeName:true}}\n                                        </span>\n                                    <span class=\"event-title\" ng-bind-html=\"event.title\"></span>\n                                </a>\n                            </li>\n                        </ul>\n                    </li>\n                </ul>\n            </div>\n        </ui-view>\n    </div>\n</div>\n"

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(425);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Date format used to access events
	 * @type {string}
	 */
	var DATE_FORMAT = 'YYYY-MM-DD';
	
	var EventsController = function () {
	  EventsController.$inject = ["EventsService", "OfficesService", "$window", "$q", "$state"];
	  function EventsController(EventsService, OfficesService, $window, $q, $state) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, EventsController);
	    (0, _assign2.default)(this, { EventsService: EventsService, OfficesService: OfficesService, $state: $state });
	    this.events = {}; // empty object to avoid initial errors
	    this.selectedDay = null;
	    this.calendarOptions = {
	      customClass: this.getDayClass.bind(this),
	      minDate: new Date(),
	      showWeeks: false
	    };
	    // since offices are used for visualization, resolve all promises at the same time
	    var eventsPromise = EventsService.list(),
	        officesPromise = OfficesService.list();
	    // when both promises are resolved
	    $q.all([eventsPromise, officesPromise]).then(function (results) {
	      var events = results[0],
	          offices = results[1];
	      console.debug('Offices and events retrieved');
	      // assign offices
	      _this.offices = _lodash2.default.keyBy(offices, 'id');
	      // group events by starting day, start_timestamp is a moment object
	      _this.events = _lodash2.default.groupBy(events, function (e) {
	        return e.start_timestamp.format(DATE_FORMAT);
	      });
	      // trigger the watcher after events are loaded to show events on calendar
	      _this.selectedDay = new Date();
	    });
	    // true iff on tablet
	    this.bigScreen = $window.innerWidth >= 768;
	    // past event filter
	    this.showPastEvents = false;
	  }
	
	  /**
	   * Used to customize class for day icons
	   */
	
	
	  (0, _createClass3.default)(EventsController, [{
	    key: 'getDayClass',
	    value: function getDayClass(data) {
	      return this.hasEvents(data.date) ? 'full' : '';
	    }
	
	    /**
	     * Return true if there are events for currently selected day
	     * @param day to check as javascript Date object
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'hasEvents',
	    value: function hasEvents(day) {
	      return !_lodash2.default.isEmpty(this.events[(0, _moment2.default)(day).format(DATE_FORMAT)]);
	    }
	
	    /**
	     * Return a list of offices with events for selected day
	     * @param day
	     * @returns {*} list of unique offices for selected day
	     */
	
	  }, {
	    key: 'getOfficesFor',
	    value: function getOfficesFor(day) {
	      // involved offices for tablet lists
	      return (0, _lodash2.default)(this.events[(0, _moment2.default)(day).format(DATE_FORMAT)]).map('id_sede').uniq().value();
	    }
	
	    /**
	     * Return a sorted list of events for selected day
	     * @param day
	     * @param office_id
	     * @returns {*}
	     */
	
	  }, {
	    key: 'getEventsFor',
	    value: function getEventsFor(day, office_id) {
	      return (0, _lodash2.default)(this.events[(0, _moment2.default)(day).format(DATE_FORMAT)]).filter({ id_sede: office_id }).value();
	    }
	
	    /**
	     * Select an event in the interface
	     * @param event selected event
	     */
	
	  }, {
	    key: 'selectEvent',
	    value: function selectEvent(event) {
	      this.$state.go('events.event', { officeId: event.id_sede, eventId: event.id_elemento });
	    }
	  }, {
	    key: 'togglePastEvents',
	    value: function togglePastEvents() {
	      this.showPastEvents = !this.showPastEvents;
	    }
	  }, {
	    key: 'isDateShown',
	    value: function isDateShown(date) {
	      return this.showPastEvents || (0, _moment2.default)(date, DATE_FORMAT).isAfter((0, _moment2.default)().add(-1, 'days'));
	    }
	  }, {
	    key: 'officeName',
	    value: function officeName(id) {
	      return _lodash2.default.has(this.offices, id) ? this.offices[id].label : '';
	    }
	  }, {
	    key: 'ifFullDay',
	    value: function ifFullDay(event) {
	      return event.start_timestamp.format('HH:mm:ss') == '00:00:00';
	    }
	  }, {
	    key: 'eventTime',
	    value: function eventTime(event) {
	      return event.start_timestamp.format('HH:mm') + ' ' + (0, _moment2.default)(event.a, 'DD/MM/YYYY HH:mm').format('HH:mm');
	    }
	  }]);
	  return EventsController;
	}();
	
	exports.default = EventsController;

/***/ },
/* 425 */,
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 427,
		"./af.js": 427,
		"./ar": 428,
		"./ar-dz": 429,
		"./ar-dz.js": 429,
		"./ar-ly": 430,
		"./ar-ly.js": 430,
		"./ar-ma": 431,
		"./ar-ma.js": 431,
		"./ar-sa": 432,
		"./ar-sa.js": 432,
		"./ar-tn": 433,
		"./ar-tn.js": 433,
		"./ar.js": 428,
		"./az": 434,
		"./az.js": 434,
		"./be": 435,
		"./be.js": 435,
		"./bg": 436,
		"./bg-x": 437,
		"./bg-x.js": 437,
		"./bg.js": 436,
		"./bn": 438,
		"./bn.js": 438,
		"./bo": 439,
		"./bo.js": 439,
		"./br": 440,
		"./br.js": 440,
		"./bs": 441,
		"./bs.js": 441,
		"./ca": 442,
		"./ca.js": 442,
		"./cs": 443,
		"./cs.js": 443,
		"./cv": 444,
		"./cv.js": 444,
		"./cy": 445,
		"./cy.js": 445,
		"./da": 446,
		"./da.js": 446,
		"./de": 447,
		"./de-at": 448,
		"./de-at.js": 448,
		"./de.js": 447,
		"./dv": 449,
		"./dv.js": 449,
		"./el": 450,
		"./el.js": 450,
		"./en-au": 451,
		"./en-au.js": 451,
		"./en-ca": 452,
		"./en-ca.js": 452,
		"./en-gb": 453,
		"./en-gb.js": 453,
		"./en-ie": 454,
		"./en-ie.js": 454,
		"./en-nz": 455,
		"./en-nz.js": 455,
		"./eo": 456,
		"./eo.js": 456,
		"./es": 457,
		"./es-do": 458,
		"./es-do.js": 458,
		"./es.js": 457,
		"./et": 459,
		"./et.js": 459,
		"./eu": 460,
		"./eu.js": 460,
		"./fa": 461,
		"./fa.js": 461,
		"./fi": 462,
		"./fi.js": 462,
		"./fo": 463,
		"./fo.js": 463,
		"./fr": 464,
		"./fr-ca": 465,
		"./fr-ca.js": 465,
		"./fr-ch": 466,
		"./fr-ch.js": 466,
		"./fr.js": 464,
		"./fy": 467,
		"./fy.js": 467,
		"./gd": 468,
		"./gd.js": 468,
		"./gl": 469,
		"./gl.js": 469,
		"./he": 470,
		"./he.js": 470,
		"./hi": 471,
		"./hi.js": 471,
		"./hr": 472,
		"./hr.js": 472,
		"./hu": 473,
		"./hu.js": 473,
		"./hy-am": 474,
		"./hy-am.js": 474,
		"./id": 475,
		"./id.js": 475,
		"./is": 476,
		"./is.js": 476,
		"./it": 477,
		"./it.js": 477,
		"./ja": 478,
		"./ja.js": 478,
		"./jv": 479,
		"./jv.js": 479,
		"./ka": 480,
		"./ka.js": 480,
		"./kk": 481,
		"./kk.js": 481,
		"./km": 482,
		"./km.js": 482,
		"./ko": 483,
		"./ko.js": 483,
		"./ky": 484,
		"./ky.js": 484,
		"./lb": 485,
		"./lb.js": 485,
		"./lo": 486,
		"./lo.js": 486,
		"./lt": 487,
		"./lt.js": 487,
		"./lv": 488,
		"./lv.js": 488,
		"./me": 489,
		"./me.js": 489,
		"./mi": 490,
		"./mi.js": 490,
		"./mk": 491,
		"./mk.js": 491,
		"./ml": 492,
		"./ml.js": 492,
		"./mr": 493,
		"./mr.js": 493,
		"./ms": 494,
		"./ms-my": 495,
		"./ms-my.js": 495,
		"./ms.js": 494,
		"./my": 496,
		"./my.js": 496,
		"./nb": 497,
		"./nb.js": 497,
		"./ne": 498,
		"./ne.js": 498,
		"./nl": 499,
		"./nl-be": 500,
		"./nl-be.js": 500,
		"./nl.js": 499,
		"./nn": 501,
		"./nn.js": 501,
		"./pa-in": 502,
		"./pa-in.js": 502,
		"./pl": 503,
		"./pl.js": 503,
		"./pt": 504,
		"./pt-br": 505,
		"./pt-br.js": 505,
		"./pt.js": 504,
		"./ro": 506,
		"./ro.js": 506,
		"./ru": 507,
		"./ru.js": 507,
		"./se": 508,
		"./se.js": 508,
		"./si": 509,
		"./si.js": 509,
		"./sk": 510,
		"./sk.js": 510,
		"./sl": 511,
		"./sl.js": 511,
		"./sq": 512,
		"./sq.js": 512,
		"./sr": 513,
		"./sr-cyrl": 514,
		"./sr-cyrl.js": 514,
		"./sr.js": 513,
		"./ss": 515,
		"./ss.js": 515,
		"./sv": 516,
		"./sv.js": 516,
		"./sw": 517,
		"./sw.js": 517,
		"./ta": 518,
		"./ta.js": 518,
		"./te": 519,
		"./te.js": 519,
		"./tet": 520,
		"./tet.js": 520,
		"./th": 521,
		"./th.js": 521,
		"./tl-ph": 522,
		"./tl-ph.js": 522,
		"./tlh": 523,
		"./tlh.js": 523,
		"./tr": 524,
		"./tr.js": 524,
		"./tzl": 525,
		"./tzl.js": 525,
		"./tzm": 526,
		"./tzm-latn": 527,
		"./tzm-latn.js": 527,
		"./tzm.js": 526,
		"./uk": 528,
		"./uk.js": 528,
		"./uz": 529,
		"./uz.js": 529,
		"./vi": 530,
		"./vi.js": 530,
		"./x-pseudo": 531,
		"./x-pseudo.js": 531,
		"./zh-cn": 532,
		"./zh-cn.js": 532,
		"./zh-hk": 533,
		"./zh-hk.js": 533,
		"./zh-tw": 534,
		"./zh-tw.js": 534
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 426;


/***/ },
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(536);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./events.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./events.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".event-list-phones .glyphicon,.event-list-sidebar .glyphicon{display:inline-block;font-family:FontAwesome;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.event-list-phones .glyphicon-chevron-left:before,.event-list-sidebar .glyphicon-chevron-left:before{content:\"\\F053\"}.event-list-phones .glyphicon-chevron-right:before,.event-list-sidebar .glyphicon-chevron-right:before{content:\"\\F054\"}.event-list-phones .full button span,.event-list-sidebar .full button span{background-color:#00d5c3;border-radius:50%;color:#000}.event-list-phones .events-date-picker,.event-list-sidebar .events-date-picker{margin:0 auto;display:inline-block}.event-list-phones .event-list a,.event-list-sidebar .event-list a{cursor:pointer}.event-list-phones .event-list-events li,.event-list-sidebar .event-list-events li{text-transform:uppercase}@media (max-width:768px){.event-list-phones,.event-list-sidebar{margin-top:-20px}.event-list-phones .event-item,.event-list-sidebar .event-item{margin-left:15px!important;margin-right:15px!important}}.event-list-phones .past-event-toggler,.event-list-sidebar .past-event-toggler{margin-top:20px;margin-right:15px;margin-left:15px}.event-list-phones .past-event-toggler p,.event-list-sidebar .past-event-toggler p{text-align:right}.event-list-phones .event-item,.event-list-sidebar .event-item{margin-left:-15px;margin-right:-15px}.event-list-phones .event-item .date-or-office,.event-list-sidebar .event-item .date-or-office{background-color:#f5f5f5;display:block;color:#383838;font-family:Lato,sans-serif;font-weight:700;padding-left:15px;padding-right:15px;margin-bottom:.5em}.event-list-phones .event-item ul,.event-list-sidebar .event-item ul{padding-left:15px;padding-right:15px}.event-list-phones .event-office,.event-list-phones .hours,.event-list-sidebar .event-office,.event-list-sidebar .hours{color:#00d5c3}.event-list-phones .event-title,.event-list-sidebar .event-title{color:#f5f5f5}.event-list-phones .event-office,.event-list-phones .event-title,.event-list-sidebar .event-office,.event-list-sidebar .event-title{display:block;text-transform:uppercase}.event-list-phones{font-family:Lato-Light,sans-serif}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/components/events/events.scss","/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/bootstrap-customizations.scss"],"names":[],"mappings":"AAGA,6DAII,qBACA,wBACA,kBACA,gBACA,cACA,mCACA,iCAAkC,CAVtC,qGAaI,eAAgB,CAbpB,uGAgBI,eAAgB,CAhBpB,2EAoBI,yBACA,kBACA,UAAY,CAtBhB,+EA0BI,cACA,oBAAqB,CA3BzB,mEA+BI,cAAe,CA/BnB,mFAoCM,wBAAyB,CAC1B,yBArCL,uCAyCI,gBAAiB,CAzCrB,+DA2CM,2BACA,2BAA6B,CAC9B,CA7CL,+EAiDI,gBACA,kBACA,gBAAiB,CAnDrB,mFAqDM,gBAAiB,CArDvB,+DA2DI,kBACA,kBAAmB,CA5DvB,+FA+DM,yBACA,cACA,cCpBJ,4BDsBI,gBAEA,kBACA,mBAEA,kBAAoB,CAxE1B,qEA4EM,kBACA,kBAAmB,CA7EzB,wHAmFI,aC5Ea,CDPjB,iEAuFI,aCtFgB,CDDpB,oIA2FI,cACA,wBAAyB,CAC1B,mBC5CD,iCAAqC,CDmDtC","file":"events.scss","sourcesContent":["@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss\";\n@import '../../bootstrap-customizations';\n\n.event-list-sidebar, .event-list-phones {\n  // CSS hack to use font awesome icons instead of glyphicons\n  // @see https://github.com/angular-ui/bootstrap/issues/2475#issuecomment-57182139\n  .glyphicon {\n    display: inline-block;\n    font-family: FontAwesome;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  .glyphicon-chevron-left:before {\n    content: \"\\f053\";\n  }\n  .glyphicon-chevron-right:before {\n    content: \"\\f054\";\n  }\n\n  .full button span {\n    background-color: $brand-primary;\n    border-radius: 50%;\n    color: black;\n  }\n\n  .events-date-picker {\n    margin: 0 auto;\n    display: inline-block;\n  }\n\n  .event-list a {\n    cursor: pointer;\n  }\n\n  .event-list-events {\n    li {\n      text-transform: uppercase;\n    }\n  }\n\n  @media (max-width: $screen-sm-min) {\n    margin-top: -20px;\n    .event-item {\n      margin-left: 15px !important;\n      margin-right: 15px !important;\n    }\n  }\n\n  .past-event-toggler {\n    margin-top: 20px;\n    margin-right: 15px;\n    margin-left: 15px;\n    p {\n      text-align: right;\n    }\n  }\n\n  .event-item {\n\n    margin-left: -15px;\n    margin-right: -15px;\n\n    .date-or-office {\n      background-color: $whitesmoke;\n      display: block;\n      color: darken($appGrey, 50%);\n      @include normalFont();\n      font-weight: bold;\n\n      padding-left: 15px;\n      padding-right: 15px;\n\n      margin-bottom: 0.5em;\n    }\n\n    ul {\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n  }\n\n  // used for both kind of lists\n  .event-office, .hours {\n    color: $brand-primary;\n  }\n\n  .event-title {\n    color: $whitesmoke;\n  }\n\n  .event-office, .event-title {\n    display: block;\n    text-transform: uppercase;\n  }\n\n}\n\n// phone styles\n.event-list-phones {\n  @include lightFont();\n}\n","//noinspection CssUnknownTarget\n@import url(//fonts.googleapis.com/css?family=Lato);\n\n// default color for texts\n$whitesmoke: #f5f5f5;\n\n// APP colors\n$appGrey: #B7B7B7;\n$appDarkBlue: #21242A;\n$appTransparentBlue: rgba(37, 40, 47, 0.7);\n$appAqua: #00D5C3;\n\n// Customize Bootstrap variables that get imported before the original Bootstrap variables.\n// Thus original Bootstrap variables can depend on values from here.\n$brand-primary: $appAqua;\n\n// customize app fonts and size\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n\n//** Global text color on `<body>`.\n$text-color: $whitesmoke !default;\n\n//== Typography\n//\n//## Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n$font-family-serif: Georgia, \"Times New Roman\", Times, serif !default;\n//** Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`.\n$font-family-monospace: Menlo, Monaco, Consolas, \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 14px !default;\n$font-size-large: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-small: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n$font-size-h1: floor(($font-size-base * 2.6)) !default; // ~36px\n$font-size-h2: floor(($font-size-base * 2.15)) !default; // ~30px\n$font-size-h3: ceil(($font-size-base * 1.7)) !default; // ~24px\n$font-size-h4: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-h5: $font-size-base !default;\n$font-size-h6: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n// Remove navbar backgrounds and colors\n$navbar-default-color: transparent !default;\n$navbar-default-bg: transparent !default;\n\n@mixin normalFont {\n  font-family: 'Lato', sans-serif;\n}\n\n@mixin lightFont {\n  font-family: 'Lato-Light', sans-serif;\n}\n\n@mixin normalH2 {\n  font-size: 25px;\n  @include lightFont();\n  color: $appAqua;\n}\n\n//Alloy.Globals.Typo = {\n//\th1: { fontSize: 40, fontFamily:'Lato-Light' },\n//\th1bold: { fontSize: 40, fontFamily:'Lato-Bold' },\n//\th2: { fontSize: 25, fontFamily:'Lato-Light' },\n//\th2bold: { fontSize: 25, fontFamily:'Lato-Bold' },\n//\th3: { fontSize: 18, fontFamily:'Lato-Light' },\n//\th3bold: { fontSize: 18, fontFamily:'Lato-Bold' },\n//\th4: { fontSize: 15, fontFamily:'Lato-Regular' },\n//\th4bold: { fontSize: 15, fontFamily:'Lato-Bold' },\n//\th5: { fontSize: 13, fontFamily:'Lato-Regular' },\n//\th5bold: { fontSize: 13, fontFamily:'Lato-Bold' }\n//};\n\n// navbar heights\n$tablet-navbar-height: 82px;\n$mobile-navbar-height: 55px;\n\n// Include this mixin to make an element scrollable within body and to take full body height\n@mixin fullBody {\n\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _event = __webpack_require__(538);
	
	var _event2 = _interopRequireDefault(_event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventModule = _angular2.default.module('event', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('events.event', {
	    url: '/:officeId/:eventId',
	    component: 'event',
	    resolve: {
	      selectedEvent: ["EventsService", "$stateParams", function selectedEvent(EventsService, $stateParams) {
	        return EventsService.details($stateParams.officeId, $stateParams.eventId);
	      }],
	      $title: ["selectedEvent", function $title(selectedEvent) {
	        return 'Eventi - ' + selectedEvent.title;
	      }]
	    }
	  });
	}]).component('event', _event2.default).name;
	
	exports.default = eventModule;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _event = __webpack_require__(539);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _event3 = __webpack_require__(540);
	
	var _event4 = _interopRequireDefault(_event3);
	
	__webpack_require__(541);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventComponent = {
	  restrict: 'E',
	  bindings: { selectedEvent: '<' },
	  template: _event2.default,
	  controller: _event4.default
	};
	
	exports.default = eventComponent;

/***/ },
/* 539 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-sm-8 event-viewer\">\n    <!-- Event viewer -->\n    <div class=\"row\">\n        <!-- Event date -->\n        <div class=\"col-sm-2 hidden-xs\">\n            <small class=\"weekday\">\n                {{$ctrl.selectedEvent.start_timestamp.toDate() | date:'EEEE'}}\n            </small>\n            <small class=\"day-number\">\n                {{$ctrl.selectedEvent.start_timestamp.toDate() | date:'dd'}}\n            </small>\n        </div>\n        <!-- Event title and description -->\n        <div class=\"col-sm-10\">\n            <h3 class=\"office-name\">{{$ctrl.officeName($ctrl.selectedEvent.id_sede)}}</h3>\n            <h1 class=\"event-title\">{{$ctrl.selectedEvent.title}}</h1>\n\n            <div class=\"row event-details\">\n                <p class=\"col-xs-9\">\n                    <span class=\"when\">\n                        <fa name=\"clock-o\"></fa>\n                        {{$ctrl.ifFullDay($ctrl.selectedEvent) ? 'Tutto il giorno' : $ctrl.eventTime($ctrl.selectedEvent) }}\n                    </span>\n                    <span class=\"where\">\n                        <fa name=\"calendar\"></fa> {{$ctrl.selectedEvent.luogo}}\n                    </span>\n                </p>\n                <p class=\"col-xs-3 text-center\">\n                    <a class=\"btn btn-default btn-primary\" ng-href=\"{{$ctrl.selectedEvent.url}}\"\n                       fm-external-link>\n                        Apri\n                    </a>\n                </p>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"event-content\" ng-bind-html=\"$ctrl.selectedEvent.content\">\n    </div>\n</div>"

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(425);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventController = function () {
	  EventController.$inject = ["OfficesService"];
	  function EventController(OfficesService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, EventController);
	    (0, _assign2.default)(this, { OfficesService: OfficesService });
	    OfficesService.list().then(function (offices) {
	      return _this.offices = _lodash2.default.keyBy(offices, 'id');
	    });
	  }
	
	  (0, _createClass3.default)(EventController, [{
	    key: 'officeName',
	    value: function officeName(id) {
	      return _lodash2.default.has(this.offices, id) ? this.offices[id].label : '';
	    }
	  }, {
	    key: 'ifFullDay',
	    value: function ifFullDay(event) {
	      return event.start_timestamp.format('HH:mm:ss') == '00:00:00';
	    }
	  }, {
	    key: 'eventTime',
	    value: function eventTime(event) {
	      return event.start_timestamp.format('HH:mm') + ' ' + (0, _moment2.default)(event.a, 'DD/MM/YYYY HH:mm').format('HH:mm');
	    }
	  }]);
	  return EventController;
	}();
	
	exports.default = EventController;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(542);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./event.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./event.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".event-viewer small.weekday{text-transform:uppercase;display:block;font-size:2em}.event-viewer small.day-number{display:block;font-size:8em;margin-top:-25px}.event-viewer .event-details,.event-viewer .event-title,.event-viewer .office-name{font-family:Lato-Light,sans-serif}.event-viewer .office-name,.event-viewer span.fa{color:#00d5c3}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/events/client/app/components/events/event/event.scss","/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/events/client/app/bootstrap-customizations.scss"],"names":[],"mappings":"AAGA,4BAEI,yBACA,cACA,aAAc,CAJlB,+BAQI,cACA,cACA,gBAAiB,CAVrB,mFCiDE,iCAAqC,CDjDvC,iDAkBI,aCXa,CDYd","file":"event.scss","sourcesContent":["@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss\";\n@import '../../../bootstrap-customizations';\n\n.event-viewer {\n  small.weekday {\n    text-transform: uppercase;\n    display: block;\n    font-size: 2em;\n  }\n\n  small.day-number {\n    display: block;\n    font-size: 8em;\n    margin-top: -25px;\n  }\n\n  .event-title, .event-details, .office-name {\n    @include lightFont();\n  }\n\n  span.fa, .office-name {\n    color: $brand-primary;\n  }\n}","//noinspection CssUnknownTarget\n@import url(//fonts.googleapis.com/css?family=Lato);\n\n// default color for texts\n$whitesmoke: #f5f5f5;\n\n// APP colors\n$appGrey: #B7B7B7;\n$appDarkBlue: #21242A;\n$appTransparentBlue: rgba(37, 40, 47, 0.7);\n$appAqua: #00D5C3;\n\n// Customize Bootstrap variables that get imported before the original Bootstrap variables.\n// Thus original Bootstrap variables can depend on values from here.\n$brand-primary: $appAqua;\n\n// customize app fonts and size\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n\n//** Global text color on `<body>`.\n$text-color: $whitesmoke !default;\n\n//== Typography\n//\n//## Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n$font-family-serif: Georgia, \"Times New Roman\", Times, serif !default;\n//** Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`.\n$font-family-monospace: Menlo, Monaco, Consolas, \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 14px !default;\n$font-size-large: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-small: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n$font-size-h1: floor(($font-size-base * 2.6)) !default; // ~36px\n$font-size-h2: floor(($font-size-base * 2.15)) !default; // ~30px\n$font-size-h3: ceil(($font-size-base * 1.7)) !default; // ~24px\n$font-size-h4: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-h5: $font-size-base !default;\n$font-size-h6: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n// Remove navbar backgrounds and colors\n$navbar-default-color: transparent !default;\n$navbar-default-bg: transparent !default;\n\n@mixin normalFont {\n  font-family: 'Lato', sans-serif;\n}\n\n@mixin lightFont {\n  font-family: 'Lato-Light', sans-serif;\n}\n\n@mixin normalH2 {\n  font-size: 25px;\n  @include lightFont();\n  color: $appAqua;\n}\n\n//Alloy.Globals.Typo = {\n//\th1: { fontSize: 40, fontFamily:'Lato-Light' },\n//\th1bold: { fontSize: 40, fontFamily:'Lato-Bold' },\n//\th2: { fontSize: 25, fontFamily:'Lato-Light' },\n//\th2bold: { fontSize: 25, fontFamily:'Lato-Bold' },\n//\th3: { fontSize: 18, fontFamily:'Lato-Light' },\n//\th3bold: { fontSize: 18, fontFamily:'Lato-Bold' },\n//\th4: { fontSize: 15, fontFamily:'Lato-Regular' },\n//\th4bold: { fontSize: 15, fontFamily:'Lato-Bold' },\n//\th5: { fontSize: 13, fontFamily:'Lato-Regular' },\n//\th5bold: { fontSize: 13, fontFamily:'Lato-Bold' }\n//};\n\n// navbar heights\n$tablet-navbar-height: 82px;\n$mobile-navbar-height: 55px;\n\n// Include this mixin to make an element scrollable within body and to take full body height\n@mixin fullBody {\n\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _apps = __webpack_require__(544);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _projectManager = __webpack_require__(555);
	
	var _projectManager2 = _interopRequireDefault(_projectManager);
	
	var _youtube = __webpack_require__(561);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _newsList = __webpack_require__(575);
	
	var _newsList2 = _interopRequireDefault(_newsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appsModule = _angular2.default.module('apps', [_angularUiRouter2.default, _projectManager2.default, _youtube2.default, _newsList2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('apps', {
	    url: '/apps',
	    component: 'apps',
	    resolve: {
	      $title: function $title() {
	        return 'APPs';
	      }
	    }
	  });
	}]).component('apps', _apps2.default).name;
	
	exports.default = appsModule;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apps = __webpack_require__(545);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _apps3 = __webpack_require__(546);
	
	var _apps4 = _interopRequireDefault(_apps3);
	
	__webpack_require__(553);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _apps2.default,
	  controller: _apps4.default
	};
	
	exports.default = appsComponent;

/***/ },
/* 545 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n\n        <!-- App list -->\n        <div class=\"col-sm-1 col-xs-12 apps-list-sidebar\" ng-show=\"$ctrl.showAppMenu()\">\n\n            <div class=\"row text-center\">\n\n                <div class=\"col-xs-4 col-sm-12\" ng-repeat=\"(label, app) in $ctrl.apps\">\n                    <a ui-sref=\"{{app.state}}\" class=\"app-trigger\" ui-sref-active=\"active\">\n                        <img ng-src=\"{{app.icon}}\" class=\"app-icon\"/>\n                        <img ng-src=\"{{app.icon_active}}\" class=\"app-icon-active\"/>\n                    </a>\n                </div>\n\n            </div>\n        </div>\n\n        <!-- App body -->\n        <div class=\"col-sm-11 col-xs-12 apps-body\">\n\n            <!-- Nested view for components -->\n            <div ui-view></div>\n\n        </div>\n    </div>\n</div>"

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppsController = function () {
	  AppsController.$inject = ["AppsService", "$window", "$state", "$transitions"];
	  function AppsController(AppsService, $window, $state, $transitions) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, AppsController);
	    (0, _assign2.default)(this, { AppsService: AppsService, $state: $state });
	    this.apps = {
	      "Progetto Manager": {
	        icon: __webpack_require__(547),
	        icon_active: __webpack_require__(548),
	        state: '.projectManager'
	      },
	      "Agenda Digitale": {
	        icon: __webpack_require__(549),
	        icon_active: __webpack_require__(550),
	        state: '.digitalAgenda'
	      },
	      "Youtube": {
	        icon: __webpack_require__(551),
	        icon_active: __webpack_require__(552),
	        state: '.youtube'
	      }
	    };
	    // hide apps when on phones
	    this.isBigScreen = $window.innerWidth >= 768;
	    // start loading digital agenda on tablet
	    if (this.isBigScreen && !this.isAppSelected()) $state.go('apps.digitalAgenda');
	    // when coming back to apps link in tablet
	    $transitions.onSuccess({ to: 'apps' }, function () {
	      if (_this.isBigScreen) $state.go('apps.digitalAgenda');
	    });
	  }
	
	  /**
	   * In big screens app list is always visible, in phones only when no app is selected
	   * @returns {boolean|*}
	   */
	
	
	  (0, _createClass3.default)(AppsController, [{
	    key: 'showAppMenu',
	    value: function showAppMenu() {
	      return this.isBigScreen || !this.isAppSelected();
	    }
	
	    /**
	     * In big screens app navigator is always hidden, in phones is only visible when an app is selected
	     * @returns {boolean|*}
	     */
	
	  }, {
	    key: 'hideAppNavigator',
	    value: function hideAppNavigator() {
	      return this.showAppMenu();
	    }
	  }, {
	    key: 'isAppSelected',
	    value: function isAppSelected() {
	      return this.$state.current.name !== 'apps'; // i.e. no app selected
	    }
	  }]);
	  return AppsController;
	}();
	
	exports.default = AppsController;

/***/ },
/* 547 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 548 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAC4CAYAAAA7W2iSAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGMTA5RTBBNDVGQjMxMUU0QkQ0Q0IyNDFCOEQ2NjYwOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGMTA5RTBBNTVGQjMxMUU0QkQ0Q0IyNDFCOEQ2NjYwOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkYxMDlFMEEyNUZCMzExRTRCRDRDQjI0MUI4RDY2NjA5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkYxMDlFMEEzNUZCMzExRTRCRDRDQjI0MUI4RDY2NjA5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+yrYL9gAAGnlJREFUeNrsXQuYXEWVPjMJj4RHGhNCeKYTHgvySMNGBJZNOmFRcIUMLo9dRDKQ5RNEyLDrgqKQjosCsjATUBcRpLM8BHfZdBBFg0AHXUCEZCCIkQDphGeAJT0L4RGI2Trf/GXX1FTdW/f2vd23Z+75vvPN9H1W1V/n1DmnTtVto9//mlqYJgjOCt4N/48XvL3gbQVvIbhN8EeCN4BfB78o+CXBqwX/qZUbYGQLlXUHwZ8Q/EnBhwj+OMDbso5nviz4D4KfFPxbwY8JXtNKALYlXAJnCD4eoB0IyYqbVgDQewT/UnA1BTAYHSD4VMGnCJ7c5LL8n+BFgn8MMFMALcTj1VmCPy/4iIR29j8KvlvwdwWvTQGsjWuzBf8zDJEgxEbIq4KfF/wCxrPXBL8N3qiM89sI3g5Gzs6CJwreU/DueO9WAd67SfD1AHLlcAVwhOCLBX8FVqML8bi0FLwcxkYUFuR4jK9/LXi64GmC2x3vvU3wNwRXhhOAJwr+juBJDtf+TnAJBsVTDSofS+WnBP8d1PkYB4lkELsFfzCUAWSVdTN6up9qLOLaF5qsoRi8kwXPgSXs55J8GR1uyAHIY9wVPn7nI4JvEXyTMn4liT4r+HTBJ/lcdxOGhupQAHCc4NsFH+1xze8FXyr4v1vEdz4Y5e3wuOY1uEIPxl2Y9hifPVPw0x7gsQXZBb+vVcAjGFAnCD5O8P9YruGw3gOoX0sCyAW/X/BOlvM/ELyP4AXUusSG1ZGCzxe82XINGzb/1WoAdoNNtErwZwSfLfgdGhp0neB9BS+2nGdr9iEMJ4kH8DYPtcEV5AD0vTT06FmMiV+3nGfL+3HBmSQDuAgDt4nmooIf0dCmb2Psf91wbiJ82b2TCGDJwyrjwf5aGj7ElmcOBpwpSPCIQ3CgoQCy2pxlOL4eFbmHhh+9irrfZzg3VvCyqNRpvQBeZVGbL6ECT9LwJQ6xcUjuLsO5yRZwGwrgeYg4mJxYdnbXUkpMJ1pAnCr4p80C8GDLuMYToJz28GaK2yAQTRL3WQ/LNTYAt/YQ/yOhPlMaTKxOnzEcv0zwUY0E8B4MxCZrc0WKkycdaXEx7glrmQYFcI6lt1w0TK3NoLQefqJJq/04bgB3FPzvhuO/ov4J2pTciGdfTNGqY8l/qmoQBZlO4lSGadqxt6g/xqcGczn2d3qdlfwIhtArUMvsN1UcoiD7W86xcfWFmIHhucztPUC72KA2/1Y7xu04igLM7Lsm9k4zgEfwAfVI/GHUn8sZNXEH+gX1zy+aXJR/oP5EX/IA8dyYwGMNdJrH+SkGADmZi2fxtxogUET/BhctUhV6m+EYT5OYciX/N6ZG4oSjy6k/C+3bhvN+fueXKOI4JIg7zb/4XLPW0k4mTcVpGZOiBJDnu/SUv/fQg5pBrDW+Rv3R/f0D3rs4hvL8rI57f0L9U006LYwSwMstvsu7TTYG/hIgyt7qskZiP8GFCMtwAfVPkdVD5xiO8fTTgVEAyHp9tHZsnQXUZhCb349g4F/leA/ns+wawbt3EXxlBM95xuJCXBaFEXOlRaVuDllYuRJohOX8ZgzqYzFe7eTwTL6mG2rdzfLuj0EeUmfDc5r9FhF1RJbCUzSBOh5tsCosgCehl+mD8U/qKOiNgq9xvJZV4kHUn4LBQfPtPK79YgAAmTiWy6mOV4esx1lQ4VFRn+AfCf5H7fg3YV2HUqFnG459r86CBpkD24gxjivBOSdP+Fw/KmBZrvLpFDbaNoJ2MNE1FiFqDwPgOJjtKr1P/Qk89VBbyPvYoZ8KQKOiNgoX/vtphKpTH14e0I6NgGoNDOAZhnHqpoBqKg46I+LnTSN7Ho+JOHKSj7F+JsPlvDAAzjEc+24CrE7OM/ljwHv8wlI/NFjaNhV9p881G+qs34PQNiodLniPIADyePMXBhW2kpJBDwW8nlX/tzzOjya3mQCORm1jOfcurPMPI6jfLwzHTgkC4MmGY/9JyaHXAl7P82yXkHeskk32WR7nea3+CR7nT4V9EEWi0q2GYx1BADzUcOzOBAEYZmeNvSFBXuDfYHk2Gyy3e9zHfhqH6PaJqH6sRvV4cs5mOJkAnKr9fhPRjqRQmNDVrooRYqPxFqDYeJvgcZ9cvDMhwjr+zKDmp7oAeJAh+nFfgsBrJ++lajaSY9My+H9ewYvDtPbwmkecR7V9ZT6MsJ6mNp/uAuARFpFOCn3N0WL0ogupP55rI3Wp270+fts3Y6rnUsOxw13GE1N88ImEgHc8OQZ4Hf05W1CAd7HgtRy8gcIuPs+Ii16EZE/UxkFfCdSnMDi1Icp16mE3AZhL0c7lPeHTGXrIez0HJ3GtjrnD6s/fgwyzKO2aua3PWPOUf5RrvbfG3zYPHolxmCMeX0dj9/g89w8h/MNLQoLAO2c0IolrtcVHt6pQnhgd6/CQeoid3U6yx0Q3w1xmfyrIJnZfgC82LWB5PgPwg97TCDJFnHinj/ttAO5uuCHqbT62o3AzAH5GyRM+1qWNOLp0OYwj13c1atmASXj28FKhJj/mZUo2zVOAC7vt5MWOmubRkJ0kLL1iODbWC0BTuvzrCQWuIvjTmhm/qY7nuaxNOKbBdTRJ+rZ+RoxOfQkDjkNMBQzmSyJWV14+3QVNaIt3aHDqymgvI8bkIG9IAGgrYWEuhoMbV5lYHX+O+vet0aMiPU2oN89wvKfhsqUXgKZg6YcRF4rXUfyczDFY6UZ8gN7+IoyoSgMb7TjDePj3Teq43PYbNQBHegG4uQGF4kyu6yi5xJ3lUkWd8sT2Wwkq32avMdC0BUjUuR/jKfn0r9AAvPfLj5pYji0M7b/JSwJN+S6jaXgSxx3fb3IZRtHgTLuNXgCaQmZjhimAlQSUYVuDrfCelwp9q0VV3lClcRbXwgqgKd1g17Qdm0Y7W/xgK4Cm3SWyaTs2jUxt/6IXgOxzrdfOT07bsWm0r+HY814AshGjr4TZbRgbMs0m0yrdlV4AMj1t8EVSNZoMAF/2U6FMywwPCrqMqj3kuXrJK1+0rQEN3haybCbaxQBgr0uDPmy4Jh/w5dv4+DZx0Q4e57ZsAIBbhCybiUwphI+69AxG+Q3q39RHUtA8TN7IXKbmyTnGN/CuOHcwPBY9l8dsDgS/jkYdb9EsUROvPOZMtc00MGY5EvUPQqY2L5vFfvBGPz9HY6jEXy15LEABtodK6VMqwQ2pzzLzeoTHaeDM/2EAnhd5cOxvItRJG6wwPsdTLZwgtUHp+WtxjXR294TflOjv/1nodU2IOALDeUIbXXTz4wYATwwA4BXoQQzWPRD9O9BDOe/mXAzGnDTLCba8sc1FkFq+dyas4dG4n48/hF7Nfzlx6XMAsRud5TwMB7wvJ+/Zwp/tmQDVdT+e3yp0pAYe0wqyfM3GBCCvgb9EO8ZzYhcGsJ6+hYbnLab2ov6VpwwcZ3nz7PbbAPZ8jLHXwGXhlVG8FciBkLAMgOO1GTxbwmsGSgCGP8DxQ0XaRuHZV0CVHoVncHbXUmiWViBTKv/iIFbh0waHcXcA4UIc0eENBHjNHc/98XIp3vdkCYwJlhDOZ7lb0e2s9mYAFJ7QPQZj6R5Qg3uD5ZTXBzRw+ot/y9kDXs/wG/zPx54BwK1CptybO4Ka9aZ5sHMcCzAZKpK3KLkebgj/no/xjK3UHgA8F5LIjXw6JI9XAnNa+Qio0Z2gUl8AOIRjqpphdSljhzwheyY0xvWQxv9oEfD+iganDj5OHumdtt0KJ2AMU30blpKPkX+axVQA8q5iQjOIv4Iq5pQF/mL0aehtS7QGvhaq8yro/vMBXDvO9WIcfEoxUPaDCl2mdCLec4w3uCu0kPSZDMhO8th6y2u7yYdo8Lf+usj/e0csVTyzcSek6EqMiesVgL5DteC5ul/LlwD0s8p4fLqiHkeikuthms+Fz3Qi3sXj6Kk4lgfoD1N9e9s0ivaiwaFMufHRh2EiIzcYjp3vUJDZ0NksEf8EgOSizNNgMZ6J3+NhhS7Hbz7+RcVw4vV6X1Vck8fROa7GWL0JhstUWJ7dAPtyNAZ/TYY3F/pUCwBo2gR2kZ/G8wLwVoMDyqrpOJ+C3AcV+SYa9i6qpWacA2k5hmozzjeil10IK3Wd0ll4HcIncJ61wXaQyDEAb3e4N6MheVkYNOvw/A+ght9NOHhc/rMMxy+tJ27JdLHh2Pd97mFpmwdg2Ap9DpYkryE/HNbkVBT4NRg1vCEqr/87Gw48A3QIxs6ZkOTfwXhph4q9EhK7DkbPXVRbGMnW7gFwPx5TrNKk0rWGcN8v4YbVBeCNBgdyN6gtG3Ej74vx6TewrHaEFXoR3IbToCIPg9/4IQZrlppxUKtXYzw8CWqXO8H3ANZ5AO4RWJ8HQE1+GeVjyZuDsfBUGrhQMmm0J5n35XH6noTLntkX0uBdC70s0t1xXKZo7I8w12Qa+CmeSegcW1ItmfYgqO1daeAK2sOpttHCLEgzBweeAICHQw2Nh0U7Ds9h0P8GZvgLCQVwiSH2ydrm0KgAJIChb36wEFKjS/TOaLixYDb3j0Bjb0LBHoZUcozvT2j4DWj08YgFZgDyCjjtLNUrFWv0IzxLhvjGUnzbPcdF/OUW0+d39iPHjZVG0Llnuly3jAZvsZyDilRT0Tmw/A309hyc6HcAyihEYPaB874AkjoOludkSN18qNL1UKNr8YzvIyx2IDrTaEjXajz3fEjphhYBL4N20Keh+PO0RdeHuE6wPgCx1ukWwzE2JCqId27CeLQD1KV08DN45jo45qtw/USMe2/AB7oLZWRpuxegrUUnYMv0VRg8Mt65uYWk7wYyb5H5lSAPCfLdiF3JnLl2N5m3qdoK4+RrAOYVgMgqtk8x7bdQxtLRyvFtqTY11A5VKy3McXjejugkbynnNrYAeGdZ/GzPqEu9ABKsP9PuDec6uBcp1Xzp5y2aKx/0YUEBJBggpk1nZlKyNgVKIo2CcaIHrP8EzRR4RXSYJKNjMV7pdD+11rRNM2gpmff+PIFCLmcPA2Afmees2iCdY1OcjLQIYUGdLqfa3GhDAJRq1BRmGw+/bJsUrwHEgXbTnp8PWtoxdgBlz/mBZZBelkrin6loCHgQXKqZ9T683kTbsy3iz34ah832GubgLSLzN6bYtToqihdEkSk9i7TtnxS/8SmKd5f3pBIHFx6xqE32cw+m4FtHxwYg09GIoJjMZtbzZw4j8Dg+y9GlwwzneI70iKjAixLAzQDR9l103rb4lmEAHgc6eDI7azjHbsIUGjgjkxgAJfGkrO2zNKdBpR49BIHjUCHv7G/bY/S3UJuvRP3iOFYL8aRqwXKOZxJ4/ouTmkYMEfBOh0V5ouX8EqjTV+J4eVzLveZDGm1TO5zcyzMIc1oYOJ7t57QHDj7btmPhDPdPx1mIONfr8XjIqQ6PWs5z2O1GnG8ltboXQCuTPduN81E5PHZZ3IVpj/n5FeoPfM/3uOaTUDNLyPvrKs2maYiorCLvz6xzDirPqJcaUagwsxFhKQdr1O/LmStx3a1RmtshaSv4cnMctARnEMxttLXdSAAldcKI2dHnuo1whnlWnrOxn29Q+T6GKMlJkDqXz8ByWJETvxq+v2ozAGTaDgM891jX5c+/BpfhjqyLqCw88/9xqPqZYNel4DzOc/rfimapiGYBKIknMTm9gNPKg6wjZ+nk3BjOEX0OYy2vgOJcGk6v4PT6DxBg2BKqkPNwOMDOeaOc7TYZDvduFPyrY6wmOY1/ebMH5mYDKIljh5x2fzIc3iTSWqjy6+D3JYKSAqBKrMo+jzGo2ZvtccIUz7bcjrE4cVlvSQRQ0ihYfhwQ4LUUB1Fj9nt5DmPaveCXkuyUJhlAnThl/1BIaA6Gx851PpMXiD4Lo+gxBBVWUAtRKwGo00gYI1mAy7mivIZwGxgtIyGxnBTMeacc1nsHRs5LMHyY36YWppEtXPaPEBVZRcOY2imlFMCUUgBTSgFMAUwpBTClFMCUUgBTAFNKAUwpBTClFMAUwJRSAFNKAUwpBTAFMKUUwJRSAFNKARyaAOap9tUtnTn1rkz9+53k0yZLFulZaUtp8GfOeN0A52HOBvM1HdSaXwWLkvjrM73ktjkrt2kXWT7iGCWA/KKC5dosCj0L1+WHOYi5APWfTsEX0EQ+BlYgefwlrSlk/lBFSmagE2XESOA6U2CcKJM0AFkSebOaicMcwER8nj1sar1J9+fRK3sUCe3E2FkBF/DXJNX6vmK9eFbFpyxZvCeP3l7FPUWyfHfWUG5ZTtUW6PEY43LKu/OGclcN1+Ysxo2JOtEeGb/2kItbuBC8p9l8cvtcWxWsVprvm0f9C0qKsFj78OIs1b6FW9EqV8SYukapfA7H+lCZkkdFZYcp4dkZVF7XEH1ag2RQ5rl4dxn35xRQ9HfLOnrRDDzLZS1hm6EzFmH0yPaQZZqOOhSUOoeSwBzUR9ljjOQGPEMzsTNaz8wqzzjDYI5LcBdZOlZO6ZG6RdyldKIFCrgqldAopmdnlHcfrJj/PUqZucMvNJRbXjtJ0Q5cjgt83IgMzo+xtEcG7+5WOl9gADNKj7T5PwWL1FQNftQYpceSoSHy+NtlUGmduN/mk0q12mGwmDs8wJNl7VTUVl45XtbsgbKHrVBR7u31Uel+7SE1U1npoJUgRoxszIlKr7Y5rSWHZ82yBA70QhdQsS6DBK7xGSPLFmOrB/cWfN7dA6BjdQUgqbMd2oOU9jBKYN6iqrLKmOQ3TvY4dgbXa7mn3QyJKDgYU37ncwDV5QMbvVrnjYs6ArRHGZ2vwwTgdLBOT6LCBQersBwAwIpjBZcaylWGQZHxADJPtW8K6n5Z3qGsmUb4coqEu0Z2KjK6owPoaoVGRfX06hIALEI6qwZVMwUGganzlB07UIni3/csG7A9JIC5Vl5i3QtwbqZaULlXcQOmW6zEiqKaywmrUxAJDB2JiZKiUk1lgFZUXIoZZA73VTRJTEpnDBKek9f1NksCy1T7VHjJAeQcDd5rOgvpu8Bx8DcZJkmhigJMryOAbFBWmyWBRcXhdrHQxhiADmoIqWpqqdKBkkAlZdz2o05Y0cVmqtAKxqfpZP62gh7uWmOQsrJiektnO+8ISmeABsuFPKePa1mf9pgPYLoc2kOG1Jo6BsqCLLIUOoeKyUpVDZW+AOfnIrQlWaaDVABuxnDvAnSgXgsQHTi33NL4fVQLoKt1yllUdocGhF4uGVzotnSsnBKYKMj2aKYVWkHDlFDobsVnk/FW6bCarMUuVGQ+Kp/V/DZpjc6FxOU0ddulhMqWa1Ed9f0zLGq6iGdXaGDAvqKNY2WM37NoYLBeglbVQmVFuEfzlPaQz+ZOc4I6nMjZiCwqWa7DtM5bIjnkqNLySk9XE6ls0ZTlemUs1IXOYTN2ssr71UZ3aQt1Gkx1ZUyqT3ayqtJxvAIQHZqDb2yPVt0rrQcVzDq6KuubEKRoCLVqXmgGKiXjqBnqjfqkAMZkdvc4gFfEGFQeigC28naTPTAi+qgWFqtq4/F0GuJ5rK0MoDRmuhRnX6XFNHAGnVIAU0rHwJRSAFPSAOTBfnOEZnYvJXB7/uEggVOo/nT5Ap6TUpNUaA+Fn2TNULrgpakAriFz+l4Qv2wMDU4iSqlBABbR+BwFz4bwx1zzGlOKUYUWFDCDSh9RuuSs4WRaobsQ0pQn9xxPDlnxBGnF8b1ZqGqZNFwh7+kY2blKOJ+h2goe1fotOZRZRm+y2rv9VkKp75S5qFWUuRSwzmp7lzzq3KkJlIw6/bncJj+QL+oLIIVFUqb4HagTBZaFkwtP+PdyDymepzQeV7wbFelV7n/QZwwv4B0dStkZhLlUW4thA70X76wqHYXfv4gGbwxhalNZZzm3p9a54NFWnVRb+NKtgMdlmmuakZdrAubhwV7AcMF4Wmc+uQWLC3juYtxb0Xq4lIQS2SdyKzjfYbhfAmtajVSEZpEz+PoavjKuyRokr4S/B2vSUkAD34zxv0DmBGNZ504yL/KZp7S7rd24XPrClyzHQvNkXhtYQaGzlsbM4BqvdYImNZLzUDkd6NGm2XPZsxd6SKmsy2IanCyVV9SWV+fSG0mW6QwPrcT14ZSJHWjwErrVADfv0bHLynBS1Y5n0dZ5k6pt95GuMT69IqjbUfEZL0pKxU30pI+hVIY7lLGcK/vcSzQ4KSmnlc2r3DmLUehn3Mm2Nl03kWpbmlAQAEvoObMNBcti3FhK8awbsKXrVR07yfQQ7ywrmiUq6iD/JXBE/pnZPa5WqKlnLKeBixzVBxZo6FMZqjXv0VlN6jlDtTlKV984G7TjjnToGQuolppXpNrizIV1Ou1ZqmWi5RsMSk55d84BwD5FjVUM4M2mwesNc0oblh07SuAJBZe8UGlpST+sJ6DbYOqt/Ay5YFStYDWk+gui0nowrqzR3u2levNKAxcVX1SNQHVZpKYcp6ZyAVAuc+5GYabAYq2EeJ80uZ8k+1rw7pjq2qOM2x2W3n6zg5TkqJZjU/GwToOuOIoNQFn5LkVqekK8K4MGsvlDcVIe4C2gcMF66bh3BLxvDSVoq60O9N6wja9HP6jBAFLIjpenWsp8UCri3s5mSyD5hJpcqOpgpnfGDGTGp7G9jJhOJSpTVdqk6qO5On2iS3q4LjYJrJd6FdckYwlXyRU6cb27YLGGyz6qTmqP2YjKyFVQ66m2KW7R8Iyq4qRXLAIgI1PLw3TgRgJYgfEzhWrLvgpovPWKVVeJ4d0ljL2zqLZnm3QLViuNu8aiQoso5yTwDIXn49xsGhgoV989A2A+SLVgdhnvXY53eIXqrDSCzj2ToCLKETbeGouFWcY4urXgfakWWedG+Kpi2VUM6qQtgK9kSqW/g2phNn73BMGPCj5H8PWC38d7V2rt0It75divlrGC99yBDnK24FH4rXdeBmcdfm+ttMeVkNJHA9RFaZQ0sdfF7Znk2LnlmNiwwESaF1pfiEsfx6dQg1dBpQD6O+7Smsz4ACyt1WIjCzgyxcjX8JKbCbGhtVCzFXJUC6etofj3VEvHwDpUaCfVtvjQjYyeRkuepP8XYACT8YLB7SpfgAAAAABJRU5ErkJggg=="

/***/ },
/* 549 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 550 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 551 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 552 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(554);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./apps.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./apps.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:768px){.apps-list-sidebar{margin-top:30px}}.apps-list-sidebar .app-trigger img{max-width:54px}.apps-list-sidebar .app-trigger img.app-icon-active{display:none}.apps-list-sidebar .app-trigger img.app-icon{display:inline}.apps-list-sidebar .app-trigger.active img.app-icon{display:none!important}.apps-list-sidebar .app-trigger.active img.app-icon-active{display:inline!important}.apps-body a{cursor:pointer}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/components/apps/apps.scss"],"names":[],"mappings":"AAIE,yBAFF,mBAII,eAAgB,CAyBnB,CA7BD,oCASM,cAAe,CATrB,oDAaO,YAAa,CAbpB,6CAgBO,cAAe,CAhBtB,oDAsBM,sBAAwB,CAtB9B,2DAyBM,wBAA0B,CAC3B,aAOD,cAAe,CAChB","file":"apps.scss","sourcesContent":["@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss\";\n\n.apps-list-sidebar {\n\n  @media (max-width: $screen-sm-min) {\n    // @include img-retina('img/bg-iphone.jpg', 'img/bg-iphone@2x.jpg', 100%, 100%);\n    margin-top: 30px;\n  }\n\n  .app-trigger {\n    img {\n      max-width: 54px;\n    }\n\n    img.app-icon-active {\n       display: none;\n    }\n    img.app-icon {\n       display: inline;\n    }\n  }\n\n  .app-trigger.active {\n    img.app-icon {\n      display: none !important;\n    }\n    img.app-icon-active {\n      display: inline !important;\n    }\n  }\n\n}\n\n.apps-body {\n  a {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _projectManager = __webpack_require__(556);
	
	var _projectManager2 = _interopRequireDefault(_projectManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectManagerModule = _angular2.default.module('projectManager', [_angularUiRouter2.default]).component('projectManager', _projectManager2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('apps.projectManager', {
	    url: '/project-manager',
	    component: 'projectManager',
	    resolve: {
	      $title: function $title() {
	        return 'Progetto Manager';
	      }
	    }
	  });
	}]).name;
	
	exports.default = projectManagerModule;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _projectManager = __webpack_require__(557);
	
	var _projectManager2 = _interopRequireDefault(_projectManager);
	
	var _projectManager3 = __webpack_require__(558);
	
	var _projectManager4 = _interopRequireDefault(_projectManager3);
	
	__webpack_require__(559);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectManagerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _projectManager2.default,
	  controller: _projectManager4.default
	};
	
	exports.default = projectManagerComponent;

/***/ },
/* 557 */
/***/ function(module, exports) {

	module.exports = "<ui-view>\n    <ul class=\"list-group\">\n        <li class=\"list-group-item\" ng-repeat=\"issue in $ctrl.issues track by issue.term_id\">\n            <a ui-sref=\".list({issueId: issue.term_id, name: issue.name})\">\n                {{issue.name | uppercase}}\n            </a>\n        </li>\n    </ul>\n</ui-view>\n"

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectManagerController = function ProjectManagerController(AppsService) {
	  'ngInject';
	  // load list of issues to show in the ui
	
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, ProjectManagerController);
	  AppsService.projectManagerIssues().then(function (issues) {
	    return _this.issues = issues;
	  });
	};
	ProjectManagerController.$inject = ["AppsService"];
	
	exports.default = ProjectManagerController;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(560);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./projectManager.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./projectManager.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	
	
	// module
	exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"projectManager.scss","sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _youtube = __webpack_require__(562);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _videoItem = __webpack_require__(567);
	
	var _videoItem2 = _interopRequireDefault(_videoItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var youtubeModule = _angular2.default.module('youtube', [_angularUiRouter2.default, _videoItem2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('apps.youtube', {
	    url: '/youtube',
	    component: 'youtube',
	    resolve: {
	      videos: ["AppsService", function videos(AppsService) {
	        return AppsService.videoFeed();
	      }],
	      $title: function $title() {
	        return 'Youtube';
	      }
	    }
	  });
	}]).component('youtube', _youtube2.default).name;
	
	exports.default = youtubeModule;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _youtube = __webpack_require__(563);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _youtube3 = __webpack_require__(564);
	
	var _youtube4 = _interopRequireDefault(_youtube3);
	
	__webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var youtubeComponent = {
	  restrict: 'E',
	  bindings: { videos: '<' },
	  template: _youtube2.default,
	  controller: _youtube4.default
	};
	
	exports.default = youtubeComponent;

/***/ },
/* 563 */
/***/ function(module, exports) {

	module.exports = "<ui-view>\n    <ul class=\"list-inline row\">\n        <li class=\"video-card col-xs-12 col-sm-4 text-center\"\n            ui-sref=\".show({videoId: video.id.videoId})\"\n            ng-repeat=\"video in $ctrl.videos track by $index\">\n\n            <img class=\"video-thumbnail\" ng-src=\"{{video.snippet.thumbnails.medium.url}}\"/>\n\n            <h2 class=\"video-title\">\n                {{video.snippet.title}}\n            </h2>\n        </li>\n    </ul>\n</ui-view>"

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YoutubeController = function YoutubeController() {
	  (0, _classCallCheck3.default)(this, YoutubeController);
	
	  this.name = 'youtube';
	};
	
	exports.default = YoutubeController;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(566);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./youtube.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./youtube.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	
	
	// module
	exports.push([module.id, ".video-card{cursor:pointer}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/apps/client/app/components/apps/youtube/youtube.scss"],"names":[],"mappings":"AAAA,YACE,cAAe,CAChB","file":"youtube.scss","sourcesContent":[".video-card {\n  cursor: pointer;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _videoItem = __webpack_require__(568);
	
	var _videoItem2 = _interopRequireDefault(_videoItem);
	
	var _angularYoutubeEmbed = __webpack_require__(573);
	
	var _angularYoutubeEmbed2 = _interopRequireDefault(_angularYoutubeEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var videoItemModule = _angular2.default.module('videoItem', [_angularUiRouter2.default, _angularYoutubeEmbed2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('apps.youtube.show', {
	    url: '/:videoId',
	    component: 'videoItem',
	    resolve: {
	      video: ["AppsService", "$stateParams", function video(AppsService, $stateParams) {
	        return AppsService.videoFeed().then(function (videos) {
	          return _(videos).find(function (v) {
	            return v.id.videoId == $stateParams.videoId;
	          });
	        });
	      }],
	      $title: ["video", function $title(video) {
	        return 'Youtube - ' + video.snippet.title;
	      }]
	    }
	  });
	}]).component('videoItem', _videoItem2.default).name;
	
	exports.default = videoItemModule;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _videoItem = __webpack_require__(569);
	
	var _videoItem2 = _interopRequireDefault(_videoItem);
	
	var _videoItem3 = __webpack_require__(570);
	
	var _videoItem4 = _interopRequireDefault(_videoItem3);
	
	__webpack_require__(571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var videoItemComponent = {
	  restrict: 'E',
	  bindings: { video: '<' },
	  template: _videoItem2.default,
	  controller: _videoItem4.default
	};
	
	exports.default = videoItemComponent;

/***/ },
/* 569 */
/***/ function(module, exports) {

	module.exports = "<div class=\"single-video\">\n    <h2 class=\"video-title\">{{$ctrl.video.snippet.title}}</h2>\n    <h3>\n        <small>{{$ctrl.video.snippet.publishedAt | date}}</small>\n    </h3>\n\n    <div class=\"embed-responsive embed-responsive-16by9\">\n        <youtube-video class=\"embed-responsive-item\"\n                       video-id=\"$ctrl.video.id.videoId\"></youtube-video>\n    </div>\n</div>\n"

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoItemController = function VideoItemController($scope) {
	  'ngInject';
	  // automatically play videos when loaded
	
	  (0, _classCallCheck3.default)(this, VideoItemController);
	  $scope.$on('youtube.player.ready', function ($event, player) {
	    console.log('Play loaded video');
	    player.playVideo();
	  });
	};
	VideoItemController.$inject = ["$scope"];
	
	exports.default = VideoItemController;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(572);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./videoItem.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./videoItem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (min-width:768px){.video-title{height:66px;overflow:hidden}}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/apps/client/app/components/apps/videoItem/videoItem.scss"],"names":[],"mappings":"AAIE,yBAFF,aAGI,YACA,eAAgB,CAEnB,CAAA","file":"videoItem.scss","sourcesContent":["@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss\";\n\n.video-title {\n  // styles for tablet\n  @media (min-width: $screen-sm-min) {\n    height: 66px;\n    overflow: hidden;\n  }\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 573 */,
/* 574 */,
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _newsList = __webpack_require__(576);
	
	var _newsList2 = _interopRequireDefault(_newsList);
	
	var _newsItem = __webpack_require__(581);
	
	var _newsItem2 = _interopRequireDefault(_newsItem);
	
	__webpack_require__(587);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newsListModule = _angular2.default.module('newsList', [_angularUiRouter2.default, _newsItem2.default, 'truncate']).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('apps.digitalAgenda', {
	    url: '/digital-agenda',
	    component: 'newsList',
	    resolve: {
	      news: ["AppsService", function news(AppsService) {
	        return AppsService.digitalAgenda();
	      }],
	      navigation: function navigation() {
	        return false;
	      },
	      $title: function $title() {
	        return 'Agenda Digitale';
	      }
	    }
	  }).state('apps.projectManager.list', {
	    url: '/:issueId/list?name',
	    component: 'newsList',
	    resolve: {
	      news: ["AppsService", "$stateParams", function news(AppsService, $stateParams) {
	        return AppsService.projectManager($stateParams.issueId);
	      }],
	      navigation: function navigation() {
	        return true;
	      },
	      $title: ["$stateParams", function $title($stateParams) {
	        return 'Progetto Manager - ' + $stateParams.name;
	      }]
	    }
	  });
	}]).component('newsList', _newsList2.default).name;
	// truncate filters
	exports.default = newsListModule;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _newsList = __webpack_require__(577);
	
	var _newsList2 = _interopRequireDefault(_newsList);
	
	var _newsList3 = __webpack_require__(578);
	
	var _newsList4 = _interopRequireDefault(_newsList3);
	
	__webpack_require__(579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newsListComponent = {
	  restrict: 'E',
	  // bindings injected by resolve
	  bindings: {
	    news: '<',
	    navigation: '<'
	  },
	  template: _newsList2.default,
	  controller: _newsList4.default
	};
	
	exports.default = newsListComponent;

/***/ },
/* 577 */
/***/ function(module, exports) {

	module.exports = "<ui-view>\n    <div class=\"news-list-horizontal\">\n        <ul class=\"list-inline row-fluid\">\n            <li class=\"news-card text-center\"\n                ui-sref=\".show({newsId: news.ID})\"\n                ng-repeat=\"news in $ctrl.news track by news.ID\">\n\n                <div class=\"news-image center-cropped\"\n                     style=\"background-image: url('{{news.image}}');\">\n                    <img ng-src=\"{{news.image}}\"/>\n                </div>\n\n                <h2 class=\"news-title\" ng-bind-html=\"news.post_title | words:10\"></h2>\n\n                <h4 class=\"news-author\" ng-show=\"news.firma != 'NO'\">\n                    {{news.firma}}\n                </h4>\n\n                <div class=\"news-body\" ng-bind-html=\"news.post_content | words:60\"></div>\n            </li>\n        </ul>\n    </div>\n</ui-view>"

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsListController = function NewsListController() {
	  (0, _classCallCheck3.default)(this, NewsListController);
	};
	
	exports.default = NewsListController;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(580);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./newsList.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./newsList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".news-list-horizontal{overflow:auto}.news-list-horizontal .list-inline{white-space:nowrap}.news-list-horizontal .list-inline .news-card{cursor:pointer;text-align:center;display:inline-block;vertical-align:top;width:350px;padding:0 10px;margin-bottom:25px}.news-list-horizontal .list-inline .news-card .news-image{width:350px;display:block;margin:0 auto}.news-list-horizontal .list-inline .news-card .center-cropped{width:330px;height:225px;background:no-repeat 50%;background-size:cover;overflow:hidden;margin-bottom:25px}.news-list-horizontal .list-inline .news-card .center-cropped img{min-height:100%;min-width:100%;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.news-list-horizontal .list-inline .news-card .news-title{width:350px;white-space:normal}.news-list-horizontal .list-inline .news-card .news-author{width:350px;white-space:normal;margin-top:0;text-align:left}.news-list-horizontal .list-inline .news-card .news-body{text-align:justify;white-space:normal}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/apps/client/app/components/apps/newsList/newsList.scss"],"names":[],"mappings":"AAIA,sBAEE,aAAc,CAFhB,mCAKI,kBAAmB,CALvB,8CAQM,eACA,kBACA,qBACA,mBACA,YACA,eAEA,kBAAmB,CAfzB,0DAkBQ,YACA,cACA,aAAc,CApBtB,8DAyBQ,YACA,aACA,yBACA,sBACA,gBACA,kBAAmB,CA9B3B,kEAmCQ,gBACA,eAEA,gEAEA,wBAEA,SAAU,CA1ClB,0DA8CQ,YACA,kBAAmB,CA/C3B,2DAmDQ,YACA,mBACA,aACA,eAAgB,CAtDxB,yDA0DQ,mBACA,kBAAmB,CACpB","file":"newsList.scss","sourcesContent":["@import '../../../bootstrap-customizations';\n\n$blockWidth: 350px;\n\n.news-list-horizontal {\n\n  overflow: auto;\n\n  .list-inline {\n    white-space: nowrap;\n\n    .news-card {\n      cursor: pointer;\n      text-align: center;\n      display: inline-block;\n      vertical-align: top;\n      width: $blockWidth;\n      padding: 0 10px;\n\n      margin-bottom: 25px;\n\n      .news-image {\n        width: $blockWidth;\n        display: block;\n        margin: 0 auto;\n      }\n\n      // credits: http://stackoverflow.com/a/11552460/518204\n      .center-cropped {\n        width: 330px;\n        height: 225px;\n        background: no-repeat center center;\n        background-size: cover;\n        overflow: hidden;\n        margin-bottom: 25px;\n      }\n\n      /* Set the image to fill its parent and make transparent */\n      .center-cropped img {\n        min-height: 100%;\n        min-width: 100%;\n        /* IE 8 */\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n        /* IE 5-7 */\n        filter: alpha(opacity=0);\n        /* modern browsers */\n        opacity: 0;\n      }\n\n      .news-title {\n        width: $blockWidth;\n        white-space: normal;\n      }\n\n      .news-author {\n        width: $blockWidth;\n        white-space: normal;\n        margin-top: 0;\n        text-align: left;\n      }\n\n      .news-body {\n        text-align: justify;\n        white-space: normal;\n      }\n\n    }\n  }\n\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _newsItem = __webpack_require__(582);
	
	var _newsItem2 = _interopRequireDefault(_newsItem);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newsItemModule = _angular2.default.module('newsItem', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('apps.digitalAgenda.show', {
	    url: '/:newsId',
	    component: 'newsItem',
	    resolve: {
	      news: ["$stateParams", "AppsService", function news($stateParams, AppsService) {
	        return AppsService.digitalAgenda().then(function (news) {
	          return _lodash2.default.find(news, { 'ID': parseInt($stateParams.newsId) });
	        });
	      }],
	      $title: ["news", function $title(news) {
	        return 'Agenda Digitale - ' + news.post_title;
	      }]
	    }
	  }).state('apps.projectManager.list.show', {
	    url: '/:newsId',
	    component: 'newsItem',
	    resolve: {
	      news: ["$stateParams", "AppsService", function news($stateParams, AppsService) {
	        return AppsService.projectManager($stateParams.issueId).then(function (news) {
	          return _lodash2.default.find(news, { 'ID': parseInt($stateParams.newsId) });
	        });
	      }],
	      $title: ["news", function $title(news) {
	        return 'Progetto Manager - ' + news.post_title;
	      }]
	    }
	  });
	}]).component('newsItem', _newsItem2.default).name;
	
	exports.default = newsItemModule;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _newsItem = __webpack_require__(583);
	
	var _newsItem2 = _interopRequireDefault(_newsItem);
	
	var _newsItem3 = __webpack_require__(584);
	
	var _newsItem4 = _interopRequireDefault(_newsItem3);
	
	__webpack_require__(585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newsItemComponent = {
	  restrict: 'E',
	  bindings: { news: '<', newsId: '<' },
	  template: _newsItem2.default,
	  controller: _newsItem4.default
	};
	
	exports.default = newsItemComponent;

/***/ },
/* 583 */
/***/ function(module, exports) {

	module.exports = "<div class=\"single-news\">\n    <h2 class=\"news-title\">{{$ctrl.selectedNews.post_title}}</h2>\n    <h3>\n        <small>{{$ctrl.selectedNews.date | date}}</small>\n        <a ng-href=\"{{$ctrl.selectedNews.url}}\" class=\"btn btn-default pull-right hidden-xs\" fm-external-link>Apri</a>\n    </h3>\n\n    <h4 class=\"news-author\" ng-show=\"$ctrl.selectedNews.firma != 'NO'\">\n        {{$ctrl.selectedNews.firma}}\n    </h4>\n\n    <div class=\"news-body\" ng-bind-html=\"$ctrl.selectedNews.post_content\"></div>\n\n    <div ng-if=\"$ctrl.selectedNews.youtube.length\" class=\"row\">\n        <div ng-repeat=\"url in $ctrl.selectedNews.youtube\" class=\"col-xs-12 col-sm-4 mobile-padded\">\n            <div class=\"embed-responsive embed-responsive-16by9\">\n                <youtube-video class=\"embed-responsive-item\" video-url=\"url\"></youtube-video>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(425);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsItemController = function NewsItemController() {
	  (0, _classCallCheck3.default)(this, NewsItemController);
	
	  this.selectedNews = _lodash2.default.extend(this.news, { date: (0, _moment2.default)(this.news.post_date, 'YYYY-MM-DD hh:mm:ss').toDate() });
	  // fix skip empty elements
	  this.selectedNews.youtube = _lodash2.default.filter(this.selectedNews.youtube);
	};
	
	exports.default = NewsItemController;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(586);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./newsItem.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./newsItem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	
	
	// module
	exports.push([module.id, ".mobile-padded{margin-bottom:20px}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/apps/client/app/components/apps/newsItem/newsItem.scss"],"names":[],"mappings":"AAAA,eACE,kBAAmB,CAEpB","file":"newsItem.scss","sourcesContent":[".mobile-padded {\n  margin-bottom: 20px;\n\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 587 */,
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _offices = __webpack_require__(589);
	
	var _offices2 = _interopRequireDefault(_offices);
	
	var _office = __webpack_require__(594);
	
	var _office2 = _interopRequireDefault(_office);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var officesModule = _angular2.default.module('offices', [_angularUiRouter2.default, _office2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('offices', {
	    url: '/offices',
	    component: 'offices',
	    resolve: {
	      $title: function $title() {
	        return 'Sedi';
	      }
	    }
	  });
	}]).component('offices', _offices2.default).name;
	
	exports.default = officesModule;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _offices = __webpack_require__(590);
	
	var _offices2 = _interopRequireDefault(_offices);
	
	var _offices3 = __webpack_require__(591);
	
	var _offices4 = _interopRequireDefault(_offices3);
	
	__webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var officesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _offices2.default,
	  controller: _offices4.default
	};
	
	exports.default = officesComponent;

/***/ },
/* 590 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n\n        <!-- Offices list -->\n        <div class=\"col-sm-4 offices-list-sidebar\">\n\n            <ui-view>\n                <div class=\"input-group\">\n                <span class=\"input-group-addon\" id=\"basic-addon1\">\n                    <fa name=\"search\"></fa>\n                </span>\n                    <input type=\"text\" ng-model=\"titleFilter\" class=\"form-control\" placeholder=\"Cerca la tua sede...\">\n                </div>\n\n                <div class=\"office-list\">\n                    <ul class=\"list-unstyled\">\n                        <li ng-repeat=\"office in $ctrl.offices | filter:{'label': titleFilter} track by office.id\"\n                            class=\"office-item\">\n                            <h3 class=\"office-name\" ng-bind-html=\"office.label\" ng-click=\"$ctrl.selectOffice(office)\">\n                            </h3>\n                            <p class=\"address\">\n                                <a ng-href=\"{{$ctrl.getAddressURL(office.recapito)}}\" fm-external-link>\n                                    <fa name=\"map-marker\"></fa>\n                                    <span class=\"name\">{{office.recapito.indirizzo}}</span>\n                                </a>\n                            </p>\n                            <p class=\"address\">\n                                <a ng-href=\"tel://{{office.contatto.telefono}}\">\n                                    <fa name=\"phone\"></fa>\n                                    <span class=\"name\">{{office.contatto.telefono}}</span>\n                                </a>\n                            </p>\n                        </li>\n                    </ul>\n                </div>\n            </ui-view>\n\n        </div>\n\n        <!-- Map viewer -->\n        <div class=\"col-sm-8 office-map hidden-xs\" ng-if=\"$ctrl.showMap\">\n            <div map-lazy-load=\"https://maps.google.com/maps/api/js?key={{$ctrl.MapsApiKey}}\">\n                <ng-map center=\"current-location\" zoom-to-include-markers geo-callback=\"$ctrl.setUserCoords()\">\n                    <!-- User marker -->\n                    <marker position=\"current\" centered></marker>\n                    <!-- Selected office marker -->\n                    <marker position=\"{{$ctrl.officeMarker.coords}}\" ng-if=\"$ctrl.officeMarker\"></marker>\n                </ng-map>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OfficesController = function () {
	  OfficesController.$inject = ["OfficesService", "$window", "NgMap", "MapsApiKey", "$state"];
	  function OfficesController(OfficesService, $window, NgMap, MapsApiKey, $state) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, OfficesController);
	    (0, _assign2.default)(this, { NgMap: NgMap, MapsApiKey: MapsApiKey, $state: $state });
	    OfficesService.list().then(function (offices) {
	      return _this.offices = offices;
	    });
	    // show map iff on big screens
	    this.showMap = $window.innerWidth >= 768;
	  }
	
	  (0, _createClass3.default)(OfficesController, [{
	    key: 'selectOffice',
	    value: function selectOffice(office) {
	      var _this2 = this;
	
	      console.debug(office);
	      this.$state.go('offices.office', { officeId: office.id }).then(function () {
	        if (_this2.showMap) {
	          _this2.panToOffice(office);
	        }
	      });
	    }
	
	    /**
	     * Record user coordinates after geolocation
	     */
	
	  }, {
	    key: 'setUserCoords',
	    value: function setUserCoords() {
	      var _this3 = this;
	
	      this.NgMap.getMap().then(function (map) {
	        return _this3.userCoords = map.getCenter();
	      });
	    }
	  }, {
	    key: 'panToOffice',
	    value: function panToOffice(office) {
	      var _this4 = this;
	
	      console.debug('Office:', office.recapito);
	      var coords = null;
	      // function to pan map
	      var panMap = function panMap(map) {
	        console.debug('Moving to', coords);
	        map.panTo(coords);
	        _this4.officeMarker = { coords: [coords.lat, coords.lng] };
	        // record distance to office
	        if (_this4.userCoords) {
	          _this4.officeMarker.distance = OfficesController.getDistance(coords.lat, coords.lng, _this4.userCoords.lat(), _this4.userCoords.lng());
	        }
	      };
	      if (coords = OfficesController._getCoordinates(office)) {
	        this.NgMap.getMap().then(panMap);
	      } else {
	        // use geocoding to find office
	        var fullAddress = office.recapito.indirizzo + ' - ' + office.recapito.cap + ', ' + office.recapito.comune;
	        this.NgMap.getGeoLocation(fullAddress).then(function (point) {
	          console.log('Located at', point.lat(), point.lng());
	          coords = { lat: point.lat(), lng: point.lng() };
	          _this4.NgMap.getMap().then(panMap);
	        });
	      }
	    }
	  }, {
	    key: 'getAddressURL',
	    value: function getAddressURL(location) {
	      var fullAddress = location.indirizzo + ', ' + location.comune;
	      return 'http://maps.google.com?q=' + encodeURI(fullAddress);
	    }
	  }], [{
	    key: 'getDistance',
	    value: function getDistance(lat1, lon1, lat2, lon2) {
	      if (typeof lat1 == "string") lat1 = parseFloat(lat1);
	      if (typeof lat2 == "string") lat2 = parseFloat(lat2);
	      if (typeof lon1 == "string") lon1 = parseFloat(lon1);
	      if (typeof lon2 == "string") lon2 = parseFloat(lon2);
	      var toRad = function toRad(arg) {
	        return arg * Math.PI / 180;
	      };
	      var R = 6371; // km
	      var dLat = toRad(lat2 - lat1);
	      var dLon = toRad(lon2 - lon1);
	      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
	      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	      return R * c;
	    }
	  }, {
	    key: '_getCoordinates',
	    value: function _getCoordinates(office) {
	      try {
	        // since coords is not valid JSON object add quotes to it to make it working
	        return JSON.parse(office.recapito.coords.replace('lat', '"lat"').replace('lng', '"lng"'));
	      } catch (e) {
	        return null;
	      }
	    }
	  }]);
	  return OfficesController;
	}();
	
	exports.default = OfficesController;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(593);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./offices.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./offices.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".offices-list-sidebar{padding-top:20px}.offices-list-sidebar .office-name{text-transform:uppercase}.offices-list-sidebar .address span.name{color:#f5f5f5}.offices-list-sidebar .office-item{cursor:pointer}@media (min-width:768px){.offices-list-sidebar{overflow-y:auto;height:100%}}.office-map,.office-map [map-lazy-load],.office-map [map-lazy-load] ng-map{height:100%}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/components/offices/offices.scss","/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/bootstrap-customizations.scss"],"names":[],"mappings":"AAIA,sBAEE,gBAAiB,CAFnB,mCAKI,wBAAyB,CAL7B,yCAUM,aCVc,CDApB,mCAeI,cAAe,CAChB,yBAhBH,sBC6EE,gBACA,WAAY,CDxDb,CAED,2EAOM,WAAY,CACb","file":"offices.scss","sourcesContent":["@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss\";\n@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_mixins.scss\";\n@import '../../bootstrap-customizations';\n\n.offices-list-sidebar {\n\n  padding-top: 20px;\n\n  .office-name {\n    text-transform: uppercase;\n  }\n\n  .address {\n    span.name {\n      color: $whitesmoke;\n    }\n  }\n\n  .office-item {\n    cursor: pointer;\n  }\n\n  // styles for tablet\n  @media (min-width: $screen-sm-min) {\n    @include fullBody();\n  }\n}\n\n.office-map {\n  height: 100%;\n\n  [map-lazy-load] {\n    height: 100%;\n    ng-map {\n      // height: 650px;\n      height: 100%;\n    }\n  }\n}","//noinspection CssUnknownTarget\n@import url(//fonts.googleapis.com/css?family=Lato);\n\n// default color for texts\n$whitesmoke: #f5f5f5;\n\n// APP colors\n$appGrey: #B7B7B7;\n$appDarkBlue: #21242A;\n$appTransparentBlue: rgba(37, 40, 47, 0.7);\n$appAqua: #00D5C3;\n\n// Customize Bootstrap variables that get imported before the original Bootstrap variables.\n// Thus original Bootstrap variables can depend on values from here.\n$brand-primary: $appAqua;\n\n// customize app fonts and size\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n\n//** Global text color on `<body>`.\n$text-color: $whitesmoke !default;\n\n//== Typography\n//\n//## Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n$font-family-serif: Georgia, \"Times New Roman\", Times, serif !default;\n//** Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`.\n$font-family-monospace: Menlo, Monaco, Consolas, \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 14px !default;\n$font-size-large: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-small: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n$font-size-h1: floor(($font-size-base * 2.6)) !default; // ~36px\n$font-size-h2: floor(($font-size-base * 2.15)) !default; // ~30px\n$font-size-h3: ceil(($font-size-base * 1.7)) !default; // ~24px\n$font-size-h4: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-h5: $font-size-base !default;\n$font-size-h6: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n// Remove navbar backgrounds and colors\n$navbar-default-color: transparent !default;\n$navbar-default-bg: transparent !default;\n\n@mixin normalFont {\n  font-family: 'Lato', sans-serif;\n}\n\n@mixin lightFont {\n  font-family: 'Lato-Light', sans-serif;\n}\n\n@mixin normalH2 {\n  font-size: 25px;\n  @include lightFont();\n  color: $appAqua;\n}\n\n//Alloy.Globals.Typo = {\n//\th1: { fontSize: 40, fontFamily:'Lato-Light' },\n//\th1bold: { fontSize: 40, fontFamily:'Lato-Bold' },\n//\th2: { fontSize: 25, fontFamily:'Lato-Light' },\n//\th2bold: { fontSize: 25, fontFamily:'Lato-Bold' },\n//\th3: { fontSize: 18, fontFamily:'Lato-Light' },\n//\th3bold: { fontSize: 18, fontFamily:'Lato-Bold' },\n//\th4: { fontSize: 15, fontFamily:'Lato-Regular' },\n//\th4bold: { fontSize: 15, fontFamily:'Lato-Bold' },\n//\th5: { fontSize: 13, fontFamily:'Lato-Regular' },\n//\th5bold: { fontSize: 13, fontFamily:'Lato-Bold' }\n//};\n\n// navbar heights\n$tablet-navbar-height: 82px;\n$mobile-navbar-height: 55px;\n\n// Include this mixin to make an element scrollable within body and to take full body height\n@mixin fullBody {\n\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _office = __webpack_require__(595);
	
	var _office2 = _interopRequireDefault(_office);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var officeModule = _angular2.default.module('office', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('offices.office', {
	    url: '/:officeId',
	    component: 'office',
	    resolve: {
	      selectedOffice: ["OfficesService", "$stateParams", function selectedOffice(OfficesService, $stateParams) {
	        return OfficesService.getOffice($stateParams.officeId);
	      }],
	      $title: ["selectedOffice", function $title(selectedOffice) {
	        return 'Sedi - ' + selectedOffice.label;
	      }]
	    }
	  });
	}]).component('office', _office2.default).name;
	
	exports.default = officeModule;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _office = __webpack_require__(596);
	
	var _office2 = _interopRequireDefault(_office);
	
	var _office3 = __webpack_require__(597);
	
	var _office4 = _interopRequireDefault(_office3);
	
	__webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var officeComponent = {
	  restrict: 'E',
	  bindings: { selectedOffice: '<' },
	  template: _office2.default,
	  controller: _office4.default
	};
	
	exports.default = officeComponent;

/***/ },
/* 596 */
/***/ function(module, exports) {

	module.exports = "<div class=\"office-info\">\n    <h2>\n        {{$ctrl.selectedOffice.title}}\n        <small ng-if=\"$ctrl.officeMarker.distance\">{{$ctrl.officeMarker.distance | number:2}} km</small>\n    </h2>\n    <h3>{{$ctrl.selectedOffice.info}}</h3>\n\n    <ul class=\"list-unstyled info-list\">\n        <li class=\"president\">\n            <span class=\"header\">Presidente</span>\n            <span class=\"name\">{{$ctrl.selectedOffice.presidente}}</span>\n        </li>\n\n        <fm-address-box label=\"Contatti\" address=\"$ctrl.selectedOffice\"></fm-address-box>\n\n        <!-- Offices -->\n        <fm-address-box ng-repeat=\"(label, office) in $ctrl.selectedOffice.uffici\"\n                        label=\"{{label}}\" address=\"office\"></fm-address-box>\n        <!-- Delegations -->\n        <fm-address-box ng-repeat=\"(label, office) in $ctrl.selectedOffice.delegazioni\"\n                        label=\"{{label}}\" address=\"office\"></fm-address-box>\n\n    </ul>\n</div>"

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OfficeController = function OfficeController() {
	  (0, _classCallCheck3.default)(this, OfficeController);
	};
	
	exports.default = OfficeController;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(599);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./office.scss", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/sass-loader/index.js?sourceMap!./office.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	
	
	// module
	exports.push([module.id, ".office-info>h2{margin-top:0}.office-info .info-list li span:not(.fa){display:block}.office-info .info-list li span:not(.fa).header{text-transform:uppercase;font-weight:700;font-size:18px;margin-top:10px}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/offices/client/app/components/offices/office/office.scss"],"names":[],"mappings":"AAAA,gBAEI,YAAa,CAFjB,yCAMI,aAAc,CANlB,gDASM,yBACA,gBACA,eACA,eAAgB,CACjB","file":"office.scss","sourcesContent":[".office-info {\n  > h2 {\n    margin-top: 0;\n  }\n\n  .info-list li span:not(.fa) {\n    display: block;\n\n    &.header {\n      text-transform: uppercase;\n      font-weight: bold;\n      font-size: 18px;\n      margin-top: 10px;\n    }\n  }\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _settings = __webpack_require__(601);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settingsModule = _angular2.default.module('settings', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('settings', {
	    url: '/settings',
	    component: 'settings',
	    resolve: {
	      $title: function $title() {
	        return 'Impostazioni';
	      }
	    }
	  });
	}]).component('settings', _settings2.default).name;
	
	exports.default = settingsModule;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _settings = __webpack_require__(602);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _settings3 = __webpack_require__(603);
	
	var _settings4 = _interopRequireDefault(_settings3);
	
	__webpack_require__(604);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settingsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _settings2.default,
	  controller: _settings4.default
	};
	
	exports.default = settingsComponent;

/***/ },
/* 602 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n    <div class=\"row settings-row\" ng-if=\"!$ctrl.user\">\n\n        <!-- App list -->\n        <div class=\"col-sm-5 settings-sidebar hidden-xs text-center\">\n\n            <div class=\"rounded-border col-xs-offset-3 col-xs-9\">\n                <span class=\"icon-holder\">\n                    <fa name=\"lock\" size=\"3\"></fa>\n                </span>\n                <h2>Accedi all'area riservata</h2>\n                <p>\n                    Collegando Federmanager Connect al tuo account Federmanager potrai configurare l'APP per una\n                    consultazione ancora più rapida e personalizzata!\n                </p>\n            </div>\n\n        </div>\n\n        <!-- App body -->\n        <div class=\"col-sm-7 col-xs-12 settings-body text-center\">\n\n            <form name=\"loginForm\" class=\"rounded-border col-xs-offset-1 col-xs-10\">\n                <div class=\"visible-xs\">\n                    <span class=\"icon-holder\">\n                        <fa name=\"lock\" size=\"3\"></fa>\n                    </span>\n                    <h2>Accedi all'area riservata</h2>\n                </div>\n\n                <div ng-show=\"$ctrl.loginFailed\">\n                    <span class=\"icon-holder\">\n                        <fa name=\"warning\" size=\"2\"></fa>\n                    </span>\n                    <h2>Credenziali errate</h2>\n                </div>\n\n                <div class=\"form-group\" ng-class=\"{'has-error': $ctrl.loginFailed}\">\n                    <input type=\"text\" name=\"username\"\n                           ng-model=\"$ctrl.credentials.username\" class=\"form-control\"\n                           placeholder=\"Codice Federmanager\" required>\n                </div>\n                <div class=\"form-group\" ng-class=\"{'has-error': $ctrl.loginFailed}\">\n                    <input type=\"password\" name=\"password\"\n                           ng-model=\"$ctrl.credentials.password\" class=\"form-control\"\n                           placeholder=\"Password\" required>\n                </div>\n                <button type=\"submit\" class=\"btn btn-primary btn-block\"\n                        ng-click=\"$ctrl.loginUser()\"\n                        ng-disabled=\"loginForm.$invalid\">\n                    ACCEDI\n                </button>\n            </form>\n\n        </div>\n    </div>\n\n    <!-- Shown if logged in -->\n    <div class=\"row user-row\" ng-if=\"$ctrl.user\">\n\n        <!-- App list -->\n        <div class=\"col-sm-6 hidden-xs text-center\">\n\n            <div class=\"rounded-border col-xs-offset-1 col-xs-10\">\n                <h2>Area riservata</h2>\n                <p>\n                    Hai eseguito l'accesso all'Area Riservata, da qui puoi configurare Federmanager Connect.\n                </p>\n\n                <button type=\"submit\" class=\"btn btn-primary btn-block\" ng-click=\"$ctrl.logoutUser()\">\n                    LOGOUT\n                </button>\n\n            </div>\n\n        </div>\n\n        <!-- App body -->\n        <div class=\"col-sm-6 col-xs-12 settings-body text-center\">\n\n            <div class=\"user-info visible-xs\">\n                <p>\n                    Benvenuto {{$ctrl.user.nome}}\n                </p>\n\n                <button type=\"submit\" class=\"btn btn-primary btn-block\" ng-click=\"$ctrl.logoutUser()\">\n                    LOGOUT\n                </button>\n            </div>\n\n            <div class=\"rounded-border col-sm-offset-1 col-sm-10\">\n                <h2>Sedi territoriali</h2>\n                <p>\n                    Specifica su quali sedi vuoi essere aggiornato oltre alla tua sede di riferimento.\n                </p>\n\n                <ul class=\"list-group text-left office-list\">\n                    <li class=\"list-group-item active\">\n                        <fa name=\"flag\" size=\"2\"></fa>\n                        {{$ctrl.offices[$ctrl.user.id_sede].title}}\n                    </li>\n                    <li class=\"list-group-item\" ng-repeat=\"office in $ctrl.offices track by office.id\"\n                        ng-hide=\"office.id == $ctrl.user.id_sede\">\n                        <a ng-click=\"$ctrl.toggleOffice(office)\" class=\"office-toggler\">\n                            <fa name=\"{{$ctrl.isStarred(office) ? 'star' : 'star-o'}}\" size=\"2\"></fa>\n                            {{office.title}}\n                        </a>\n                    </li>\n                </ul>\n\n            </div>\n\n        </div>\n    </div>\n</div>"

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsController = function () {
	  SettingsController.$inject = ["UsersService", "OfficesService"];
	  function SettingsController(UsersService, OfficesService) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SettingsController);
	    (0, _assign2.default)(this, { UsersService: UsersService });
	    this.credentials = {};
	    this.user = UsersService.currentUser();
	    // load offices, used when logged in
	    OfficesService.list().then(function (offices) {
	      return _this.offices = _lodash2.default.keyBy(offices, 'id');
	    });
	  }
	
	  (0, _createClass3.default)(SettingsController, [{
	    key: 'loginUser',
	    value: function loginUser() {
	      var _this2 = this;
	
	      this.UsersService.login(this.credentials).then(function (user) {
	        console.debug('Logged in as', user);
	        _this2.user = user;
	        _this2.loginFailed = false;
	      }).catch(function () {
	        _this2.loginFailed = true;
	      });
	    }
	  }, {
	    key: 'logoutUser',
	    value: function logoutUser() {
	      var _this3 = this;
	
	      this.UsersService.logout().then(function () {
	        _this3.user = null;
	        _this3.credentials = {};
	      });
	    }
	  }, {
	    key: 'isStarred',
	    value: function isStarred(office) {
	      return _lodash2.default.includes(this.user.starredOffices, office.id);
	    }
	  }, {
	    key: 'toggleOffice',
	    value: function toggleOffice(office) {
	      if (this.isStarred(office)) {
	        this.user.starredOffices = _lodash2.default.without(this.user.starredOffices, office.id);
	      } else {
	        this.user.starredOffices.push(office.id);
	      }
	      // update user in local storage
	      this.UsersService.saveCurrentUser(this.user);
	    }
	  }]);
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(605);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./settings.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./settings.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".settings-row{padding-top:100px}.rounded-border{background:rgba(0,0,0,.3);padding:2%;border-radius:10px}.settings-sidebar span.icon-holder{text-align:center;display:block}.settings-sidebar p,.settings-sidebar span{color:#f5f5f5}.settings-body span.icon-holder{text-align:center;display:block}.settings-body span{color:#f5f5f5}.settings-body .user-info{margin-bottom:10px}.office-list .office-toggler{cursor:pointer}.office-list .active span.fa{color:#f5f5f5}.office-list span.fa{color:#00d5c3}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/components/settings/settings.scss","/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/bootstrap-customizations.scss"],"names":[],"mappings":"AAEA,cACE,iBAAkB,CACnB,gBAGC,0BACA,WACA,kBAAmB,CACpB,mCAIG,kBACA,aAAc,CAHlB,2CAOI,aAAiB,CAClB,gCAKC,kBACA,aAAc,CAHlB,oBAOI,aAAiB,CAPrB,0BAWI,kBAAmB,CACpB,6BAMC,cAAe,CAFnB,6BAMI,aCzCgB,CDmCpB,qBAUI,aCvCa,CDwCd","file":"settings.scss","sourcesContent":["@import '../../bootstrap-customizations';\n\n.settings-row {\n  padding-top: 100px;\n}\n\n.rounded-border {\n  background: rgba(0, 0, 0, 0.3);\n  padding: 2%;\n  border-radius: 10px;\n}\n\n.settings-sidebar {\n  span.icon-holder {\n    text-align: center;\n    display: block;\n  }\n\n  p, span {\n    color: whitesmoke;\n  }\n}\n\n.settings-body {\n  span.icon-holder {\n    text-align: center;\n    display: block;\n  }\n\n  span {\n    color: whitesmoke;\n  }\n\n  .user-info {\n    margin-bottom: 10px;\n  }\n\n}\n\n.office-list {\n  .office-toggler {\n    cursor: pointer;\n  }\n\n  .active span.fa {\n    color: $whitesmoke;\n  }\n\n  span.fa {\n    color: $brand-primary;\n  }\n\n}","//noinspection CssUnknownTarget\n@import url(//fonts.googleapis.com/css?family=Lato);\n\n// default color for texts\n$whitesmoke: #f5f5f5;\n\n// APP colors\n$appGrey: #B7B7B7;\n$appDarkBlue: #21242A;\n$appTransparentBlue: rgba(37, 40, 47, 0.7);\n$appAqua: #00D5C3;\n\n// Customize Bootstrap variables that get imported before the original Bootstrap variables.\n// Thus original Bootstrap variables can depend on values from here.\n$brand-primary: $appAqua;\n\n// customize app fonts and size\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n\n//** Global text color on `<body>`.\n$text-color: $whitesmoke !default;\n\n//== Typography\n//\n//## Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n$font-family-serif: Georgia, \"Times New Roman\", Times, serif !default;\n//** Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`.\n$font-family-monospace: Menlo, Monaco, Consolas, \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 14px !default;\n$font-size-large: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-small: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n$font-size-h1: floor(($font-size-base * 2.6)) !default; // ~36px\n$font-size-h2: floor(($font-size-base * 2.15)) !default; // ~30px\n$font-size-h3: ceil(($font-size-base * 1.7)) !default; // ~24px\n$font-size-h4: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-h5: $font-size-base !default;\n$font-size-h6: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n// Remove navbar backgrounds and colors\n$navbar-default-color: transparent !default;\n$navbar-default-bg: transparent !default;\n\n@mixin normalFont {\n  font-family: 'Lato', sans-serif;\n}\n\n@mixin lightFont {\n  font-family: 'Lato-Light', sans-serif;\n}\n\n@mixin normalH2 {\n  font-size: 25px;\n  @include lightFont();\n  color: $appAqua;\n}\n\n//Alloy.Globals.Typo = {\n//\th1: { fontSize: 40, fontFamily:'Lato-Light' },\n//\th1bold: { fontSize: 40, fontFamily:'Lato-Bold' },\n//\th2: { fontSize: 25, fontFamily:'Lato-Light' },\n//\th2bold: { fontSize: 25, fontFamily:'Lato-Bold' },\n//\th3: { fontSize: 18, fontFamily:'Lato-Light' },\n//\th3bold: { fontSize: 18, fontFamily:'Lato-Bold' },\n//\th4: { fontSize: 15, fontFamily:'Lato-Regular' },\n//\th4bold: { fontSize: 15, fontFamily:'Lato-Bold' },\n//\th5: { fontSize: 13, fontFamily:'Lato-Regular' },\n//\th5bold: { fontSize: 13, fontFamily:'Lato-Bold' }\n//};\n\n// navbar heights\n$tablet-navbar-height: 82px;\n$mobile-navbar-height: 55px;\n\n// Include this mixin to make an element scrollable within body and to take full body height\n@mixin fullBody {\n\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loaderScreen = __webpack_require__(607);
	
	var _loaderScreen2 = _interopRequireDefault(_loaderScreen);
	
	var _loader_interceptor = __webpack_require__(610);
	
	var _loader_interceptor2 = _interopRequireDefault(_loader_interceptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loaderScreenModule = _angular2.default.module('loaderScreen', [_angularUiRouter2.default]).config(["$httpProvider", function ($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push(_loader_interceptor2.default);
	}]).component('loaderScreen', _loaderScreen2.default).name;
	
	exports.default = loaderScreenModule;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loaderScreen = __webpack_require__(608);
	
	var _loaderScreen2 = _interopRequireDefault(_loaderScreen);
	
	var _loaderScreen3 = __webpack_require__(609);
	
	var _loaderScreen4 = _interopRequireDefault(_loaderScreen3);
	
	__webpack_require__(612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loaderScreenComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loaderScreen2.default,
	  controller: _loaderScreen4.default
	};
	
	exports.default = loaderScreenComponent;

/***/ },
/* 608 */
/***/ function(module, exports) {

	module.exports = "<!-- Loader overlay -->\n<div class=\"loading-overlay\" ng-show=\"$ctrl.isLoading\">\n    <div class=\"inner\">\n        <img ng-src=\"{{$ctrl.loadingImage}}\"/>\n    </div>\n</div>"

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _loader_interceptor = __webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoaderScreenController = function LoaderScreenController($rootScope) {
	  'ngInject';
	
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, LoaderScreenController);
	  this.loadingImage = __webpack_require__(611);
	  $rootScope.$on(_loader_interceptor.SHOW_EVENT, function () {
	    return _this.isLoading = true;
	  });
	  $rootScope.$on(_loader_interceptor.HIDE_EVENT, function () {
	    return _this.isLoading = false;
	  });
	};
	LoaderScreenController.$inject = ["$rootScope"];
	
	exports.default = LoaderScreenController;

/***/ },
/* 610 */
/***/ function(module, exports) {

	'use strict';
	
	loaderInterceptor.$inject = ["$q", "$rootScope"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SHOW_EVENT = exports.SHOW_EVENT = 'httpLoader:show';
	var HIDE_EVENT = exports.HIDE_EVENT = 'httpLoader:hide';
	
	/**
	 * Intercept http calls and record number of active connections, when number raises over 0 trigger a show event
	 * when number goes back to 0 trigger a hide event
	 * @param $q
	 * @param LoaderService
	 * @returns {{request: (function(*=)), response: (function(*=)), responseError: (function(*=))}}
	 */
	function loaderInterceptor($q, $rootScope) {
	  'ngInject';
	
	  var numLoadings = 0;
	  return {
	    request: function request(config) {
	      numLoadings++;
	      $rootScope.$broadcast(SHOW_EVENT);
	      return config || $q.when(config);
	    },
	    response: function response(_response) {
	      if (0 == --numLoadings) $rootScope.$broadcast(HIDE_EVENT);
	      return _response || $q.when(_response);
	    },
	    responseError: function responseError(response) {
	      if (0 == --numLoadings) $rootScope.$broadcast(HIDE_EVENT);
	      return $q.reject(response);
	    }
	  };
	}
	exports.default = loaderInterceptor;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "loading-9a22fa3d8c073a0a413af07962c4edd0.gif";

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(613);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./loaderScreen.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?sourceMap!./../../../../node_modules/sass-loader/index.js?sourceMap!./loaderScreen.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	
	
	// module
	exports.push([module.id, ".loading-overlay{position:absolute;z-index:1500;width:100%;height:100%;background:rgba(0,0,0,.4);top:0;left:0}.loading-overlay .inner{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.loading-overlay .inner img{max-width:100%}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/client/app/components/loaderScreen/loaderScreen.scss"],"names":[],"mappings":"AACA,iBACE,kBACA,aACA,WACA,YACA,0BACA,MACA,MAAO,CAPT,wBAUI,kBACA,QACA,SACA,uCACA,8BAAgC,CAdpC,4BAiBM,cAAe,CAChB","file":"loaderScreen.scss","sourcesContent":["// Loader overlay used by angular loader service\n.loading-overlay {\n  position: absolute;\n  z-index: 1500;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  top: 0;\n  left: 0;\n\n  .inner {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n\n    img {\n      max-width: 100%;\n    }\n\n  }\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _news_service = __webpack_require__(615);
	
	var _news_service2 = _interopRequireDefault(_news_service);
	
	var _events_service = __webpack_require__(617);
	
	var _events_service2 = _interopRequireDefault(_events_service);
	
	var _offices_service = __webpack_require__(618);
	
	var _offices_service2 = _interopRequireDefault(_offices_service);
	
	var _apps_service = __webpack_require__(616);
	
	var _apps_service2 = _interopRequireDefault(_apps_service);
	
	var _users_service = __webpack_require__(619);
	
	var _users_service2 = _interopRequireDefault(_users_service);
	
	var _crypt_service = __webpack_require__(620);
	
	var _crypt_service2 = _interopRequireDefault(_crypt_service);
	
	var _selda_api_service = __webpack_require__(655);
	
	var _selda_api_service2 = _interopRequireDefault(_selda_api_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// application services
	exports.default = _angular2.default.module('app.services', []).service({
	  NewsService: _news_service2.default,
	  EventsService: _events_service2.default,
	  OfficesService: _offices_service2.default,
	  AppsService: _apps_service2.default,
	  UsersService: _users_service2.default,
	  CryptService: _crypt_service2.default,
	  SeldaAPIService: _selda_api_service2.default
	}).name;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _apps_service = __webpack_require__(616);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsService = function () {
	  NewsService.$inject = ["SeldaAPIService", "$q", "$http"];
	  function NewsService(SeldaAPIService, $q, $http) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NewsService);
	    (0, _assign2.default)(this, { SeldaAPIService: SeldaAPIService, $q: $q, $http: $http });
	  }
	
	  /**
	   * Retrieve list of all news or filtered by office
	   */
	
	
	  (0, _createClass3.default)(NewsService, [{
	    key: 'list',
	    value: function list(id) {
	      return this.SeldaAPIService.requestService('news', { sedi: id ? id : '' });
	    }
	  }, {
	    key: 'carousel',
	    value: function carousel() {
	      return this.$http.get(_apps_service.CORS_PROXY + 'http://www.federmanager.it/wp-json/wp/v2/posts?filter%5Bfm_slideshow%5D=1').then(_lodash2.default.property('data')).then(function (news) {
	        return _lodash2.default.sortBy(news, 'ordinamento');
	      });
	    }
	  }, {
	    key: 'newsContent',
	    value: function newsContent(newsId, officeId) {
	      var params = { id: newsId, id_sede: officeId };
	      return this.SeldaAPIService.requestService('contenutoNews', params)
	      // service returns an array with objects, if any content is located at content element
	      .then(function (response) {
	        return response.length ? response[0].content : null;
	      });
	    }
	  }, {
	    key: 'fullNews',
	    value: function fullNews(newsId, officeId) {
	      console.debug('Returning full news for news ' + newsId + ' in office ' + officeId);
	      var newsPromise = this.list(officeId).then(function (news) {
	        return (0, _lodash2.default)(news).find(function (n) {
	          return n.id_elemento == newsId;
	        });
	      });
	      var contentPromise = this.newsContent(newsId, officeId);
	      return this.$q.all([newsPromise, contentPromise]).then(function (result) {
	        return _lodash2.default.extend(result[0], { content: result[1] });
	      });
	    }
	  }]);
	  return NewsService;
	}();
	
	exports.default = NewsService;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CORS_PROXY = undefined;
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * CORS proxy to use in requests
	 * @type {string}
	 */
	var CORS_PROXY = exports.CORS_PROXY = 'https://cors-anywhere.herokuapp.com/';
	
	var AppsService = function () {
	  AppsService.$inject = ["$http", "SeldaAPIService"];
	  function AppsService($http, SeldaAPIService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AppsService);
	    (0, _assign2.default)(this, { $http: $http, SeldaAPIService: SeldaAPIService });
	  }
	
	  (0, _createClass3.default)(AppsService, [{
	    key: 'digitalAgenda',
	    value: function digitalAgenda() {
	      return this.$http.get(CORS_PROXY + 'http://agendadigitale.federmanager.it/api/?method=last-posts').then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'projectManager',
	    value: function projectManager(id) {
	      return this.$http.get(CORS_PROXY + 'http://progettomanager.federmanager.it/read/api/?method=issue&get=' + id).then(function (r) {
	        return (0, _lodash2.default)(r.data.articles).filter('indexed').map(function (a) {
	          return _lodash2.default.extend(a, { image: a.img_url });
	        }).value();
	      });
	    }
	  }, {
	    key: 'projectManagerIssues',
	    value: function projectManagerIssues() {
	      return this.$http.get(CORS_PROXY + 'http://progettomanager.federmanager.it/read/api/?method=list-issues&listonly').then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'videoFeed',
	    value: function videoFeed() {
	      var videosUrl = 'https://www.googleapis.com/youtube/v3/search?key=AIzaSyC6YZ5ksJqgefFjuH4On2xy9Aw86UogOAw&channelId=UCIG-fwQ76W37ZFEujJYZJmQ&maxResults=50&part=snippet%2Cid&order=date&callback=JSON_CALLBACK&forUsername=Federmanager';
	      return this.$http.jsonp(videosUrl).then(function (r) {
	        return r.data.items;
	      });
	    }
	  }]);
	  return AppsService;
	}();
	
	exports.default = AppsService;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(425);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventsService = function () {
	  EventsService.$inject = ["SeldaAPIService", "$q"];
	  function EventsService(SeldaAPIService, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EventsService);
	    (0, _assign2.default)(this, { SeldaAPIService: SeldaAPIService, $q: $q });
	  }
	
	  /**
	   * Retrieve list of all offices
	   */
	
	
	  (0, _createClass3.default)(EventsService, [{
	    key: 'list',
	    value: function list() {
	      return this.SeldaAPIService.requestService('eventi', { sedi: '' })
	      // add a start date property to events as moment js object and sort events by that property
	      .then(function (events) {
	        return (0, _lodash2.default)(events).map(function (e) {
	          return _lodash2.default.extend(e, { start_timestamp: (0, _moment2.default)(e.da, 'DD/MM/YYYY HH:mm') });
	        }).sortBy('start_timestamp').value();
	      }); // unwrap returned events
	    }
	
	    /**
	     * Retrieve a single event
	     * @param officeId
	     * @param eventId
	     */
	
	  }, {
	    key: 'find',
	    value: function find(officeId, eventId) {
	      return this.SeldaAPIService.requestService('eventi', { sedi: officeId })
	      // add a start date property to events as moment js object and sort events by that property
	      .then(function (events) {
	        return (0, _lodash2.default)(events).map(function (e) {
	          return _lodash2.default.extend(e, { start_timestamp: (0, _moment2.default)(e.da, 'DD/MM/YYYY HH:mm') });
	        }).find(function (e) {
	          return e.id_elemento == eventId;
	        });
	      }); // find event identified by the given id
	    }
	
	    /**
	     * Return a full event object decorated with event content
	     * @param eventId
	     * @param officeId
	     */
	
	  }, {
	    key: 'details',
	    value: function details(officeId, eventId) {
	      // parallelize calls using $q.all
	      console.debug('Retrieving details for event', eventId, 'in office', officeId);
	      var promises = [this.find(officeId, eventId), this.SeldaAPIService.requestService('contenutoEvento', { id: eventId, id_sede: officeId })];
	
	      return this.$q.all(promises).then(function (result) {
	        var event = result[0],
	            content = _lodash2.default.isEmpty(result[1]) ? null : result[1][0].content;
	        return _lodash2.default.extend(event, { content: content });
	      });
	    }
	  }]);
	  return EventsService;
	}();
	
	exports.default = EventsService;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _apps_service = __webpack_require__(616);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OfficesService = function () {
	  OfficesService.$inject = ["SeldaAPIService", "$http", "$q"];
	  function OfficesService(SeldaAPIService, $http, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, OfficesService);
	    (0, _assign2.default)(this, { SeldaAPIService: SeldaAPIService, $http: $http, $q: $q });
	  }
	
	  /**
	   * Retrieve list of all offices
	   */
	
	
	  (0, _createClass3.default)(OfficesService, [{
	    key: 'list',
	    value: function list() {
	      var _this = this;
	
	      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (!this._memoizedList) {
	        // original implementation without cache
	        var _list = function _list(id) {
	          var officesP = _this.SeldaAPIService.requestService('sediFDM', { sedi: id ? id : '' });
	          var namesP = _this.officeNames();
	          return _this.$q.all([officesP, namesP]) // extend returned offices with combined name
	          .then(_lodash2.default.spread(function (offices, names) {
	            return (0, _lodash2.default)(offices).map(function (office) {
	              return _lodash2.default.extend(office, { label: names[office.id] || office.title });
	            }).sortBy(function (office) {
	              return office.id == 100 ? 'AAAAAAAAAA' : office.label.toLowerCase();
	            }).value();
	          }));
	        };
	        // memoize the function
	        this._memoizedList = _lodash2.default.memoize(_list);
	      }
	      // call the memoized function
	      return this._memoizedList(id);
	    }
	  }, {
	    key: 'officeNames',
	    value: function officeNames() {
	      return this.$http.get(_apps_service.CORS_PROXY + 'http://www.federmanager.it/wp-json/wp/v2/associazione?per_page=100').then(function (offices) {
	        return (0, _lodash2.default)(offices.data).keyBy(function (o) {
	          return o.id_aplbo * 1;
	        }).mapValues(_lodash2.default.property('title.rendered')).value();
	      });
	    }
	
	    /**
	     * Returns a single office as a promise
	     * @param id
	     * @returns {*|Promise.<TResult>}
	     */
	
	  }, {
	    key: 'getOffice',
	    value: function getOffice(id) {
	      return this.list().then(function (list) {
	        return (0, _lodash2.default)(list).find(function (office) {
	          return office.id == id;
	        });
	      });
	    }
	  }]);
	  return OfficesService;
	}();
	
	exports.default = OfficesService;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersService = function () {
	  UsersService.$inject = ["SeldaAPIService", "$q", "localStorageService"];
	  function UsersService(SeldaAPIService, $q, localStorageService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, UsersService);
	    (0, _assign2.default)(this, { SeldaAPIService: SeldaAPIService, $q: $q, localStorageService: localStorageService });
	  }
	
	  (0, _createClass3.default)(UsersService, [{
	    key: 'login',
	    value: function login(credentials) {
	      var _this = this;
	
	      var params = { matricola: credentials.username, password: credentials.password };
	      return this.SeldaAPIService.requestService('login', params)
	      // if login is correct an array with one user is returned else [false] is returned as data
	      .then(function (response) {
	        return response[0] ? response[0] : _this.$q.reject('No such user');
	      }).then(this.saveCurrentUser.bind(this));
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      console.debug('Logging out user');
	      this.localStorageService.remove('currentUser');
	      return this.$q.when(); // return a promise just in case
	    }
	  }, {
	    key: 'saveCurrentUser',
	    value: function saveCurrentUser(user) {
	      user.starredOffices = user.starredOffices || [];
	      this.localStorageService.set('currentUser', user);
	      console.debug('Saving logged in user', user, 'in localstorage');
	      return user;
	    }
	
	    /**
	     * Return application current user if any
	     */
	
	  }, {
	    key: 'currentUser',
	    value: function currentUser() {
	      return this.localStorageService.get('currentUser');
	    }
	  }]);
	  return UsersService;
	}();
	
	exports.default = UsersService;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cryptoJs = __webpack_require__(621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENCRYPTION_KEY = 'f15D@m9$',
	    ENCRYPTION_IV = 'kFc#MptC';
	
	var CryptService = function () {
	  function CryptService() {
	    'ngInject';
	    // parse keys as binary from utf8 source string
	
	    (0, _classCallCheck3.default)(this, CryptService);
	    this.encryption_key = _cryptoJs.enc.Utf8.parse(ENCRYPTION_KEY);
	    this.encryption_iv = _cryptoJs.enc.Utf8.parse(ENCRYPTION_IV);
	  }
	
	  (0, _createClass3.default)(CryptService, [{
	    key: 'encrypt',
	    value: function encrypt(message) {
	      return _cryptoJs.DES.encrypt(message, this.encryption_key, { iv: this.encryption_iv, mode: _cryptoJs.mode.CBC, padding: _cryptoJs.pad.Pkcs7 }).toString();
	    }
	  }, {
	    key: 'decrypt',
	    value: function decrypt(cryptogram) {
	      var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _cryptoJs.enc.Utf8;
	
	      // cryptjs does not handles spaces in base64 encoding, remove all of them before decrypting
	      return _cryptoJs.DES.decrypt(cryptogram.replace(/\s/g, ''), this.encryption_key, { iv: this.encryption_iv, mode: _cryptoJs.mode.CBC, padding: _cryptoJs.pad.Pkcs7 }).toString(encoding);
	    }
	  }, {
	    key: 'sign',
	    value: function sign(payload) {
	      return (0, _cryptoJs.MD5)(payload).toString();
	    }
	  }, {
	    key: 'decryptAndVerify',
	    value: function decryptAndVerify(response, field) {
	      var signature = response.MD5,
	          payload = response[field];
	      var clearText = this.decrypt(payload);
	      if (signature !== this.sign(clearText)) {
	        throw new Error("Invalid signature detected, signature '" + signature + "' doesn't match clear text: " + clearText);
	      }
	      return JSON.parse(clearText);
	    }
	  }]);
	  return CryptService;
	}();
	
	exports.default = CryptService;

/***/ },
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(656);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(386);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(319);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(320);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _cryptoJs = __webpack_require__(621);
	
	var _lodash = __webpack_require__(409);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(425);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Key used to store current token in local storage
	 * @type {string}
	 */
	var MBAAS_TOKEN_KEY = 'mbaasToken';
	/**
	 * Key used to store token expiration as timestamp
	 * @type {string}
	 */
	var MBAAS_TOKEN_EXPIRE = 'mbaasTokenExpire';
	
	var SeldaAPIService = function () {
	  SeldaAPIService.$inject = ["CryptService", "$http", "$httpParamSerializerJQLike", "localStorageService", "$q", "Rollbar"];
	  function SeldaAPIService(CryptService, $http, $httpParamSerializerJQLike, localStorageService, $q, Rollbar) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, SeldaAPIService);
	    (0, _assign2.default)(this, { $http: $http, CryptService: CryptService, $httpParamSerializerJQLike: $httpParamSerializerJQLike, localStorageService: localStorageService, $q: $q, Rollbar: Rollbar });
	    // static authentication parameters
	    this.authParams = {
	      "customer_KEY": 'FDM_FDM', // chiave univoca del cliente [obbligatorio]
	      "app_KEY": 'FDM_FMConnect', // chiave univoca dell'app [obbligatorio]
	      "app_VER": '1.1.0', // versione dell'app [obbligatorio]
	      "os_KEY": 'ios' };
	    this.basicAuth = _cryptoJs.enc.Base64.stringify(_cryptoJs.enc.Utf8.parse('key_FMC_001:KeY@105#fmC'));
	  }
	
	  /**
	   * Return a promise resolved with a token used to authenticate requests.
	   * If a previous token has been requested and is still valid it will return that token.
	   * Otherwise if no token present or if expired a new one is requested.
	   */
	
	
	  (0, _createClass3.default)(SeldaAPIService, [{
	    key: 'requestToken',
	    value: function requestToken() {
	      var _this = this;
	
	      var message = (0, _stringify2.default)(this.authParams);
	      var encryptedPayload = {
	        mbaas_token_request: this.CryptService.encrypt(message),
	        MD5: this.CryptService.sign(message)
	      };
	      // if a token is present use that token
	      var currentToken = this._retrieveToken();
	      if (currentToken) return this.$q.when(currentToken);
	      // else fetch a new one and store it in local storage
	      this._tokenRequest = this._tokenRequest || this._makeRequest('https://mbaas.selda.it/APIV1/requestToken', encryptedPayload).then(function (a) {
	        try {
	          var response = _this.CryptService.decryptAndVerify(a.data, 'mbaas_token_response');
	          _this._saveToken(response);
	          return response.token;
	        } catch (e) {
	          var payload = JSON.parse(_this.CryptService.decrypt(a.data.mbaas_token_response));
	          _this.Rollbar.error('Verification mismatch when requesting token:', e, { error: payload });
	          return _this.$q.reject(payload);
	        }
	      });
	      // return the memoized request, i.e. do the request once per class
	      return this._tokenRequest;
	    }
	  }, {
	    key: 'requestService',
	    value: function requestService(service) {
	      var _this2 = this;
	
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var payload = _lodash2.default.extend({}, params, { richiesta: service });
	      // userID and UID are mandatory (??) for service request, can be anything???
	      payload = _lodash2.default.extend({}, this.authParams, { payload: payload, userID: '1', UID: '11', ws_KEY: 'FDM_WS_FMC_01' });
	      // get a valid token and then make the request
	      return this.requestToken().then(function (token) {
	        payload.token = token;
	        var message = (0, _stringify2.default)(payload);
	        var encryptedPayload = {
	          mbaas_service_request: _this2.CryptService.encrypt(message),
	          MD5: _this2.CryptService.sign(message)
	        };
	        console.debug('Requesting service ' + service + ' to SeldaAPI with params', params);
	        return _this2._makeRequest('https://mbaas.selda.it/APIV1/requestService', encryptedPayload).then(function (a) {
	          try {
	            var response = _this2.CryptService.decryptAndVerify(a.data, 'mbaas_service_response');
	            return response.payload;
	          } catch (e) {
	            var _payload = JSON.parse(_this2.CryptService.decrypt(a.data.mbaas_service_response));
	            _this2.Rollbar.error('Verification mismatch when requesting service \'' + service + '\'', e, { params: params });
	            return _this2.$q.reject(_payload);
	          }
	        });
	      });
	    }
	  }, {
	    key: '_makeRequest',
	    value: function _makeRequest(url, params) {
	      // combine all headers to make a request to MBAAS
	      var requestHeaders = _lodash2.default.extend({}, this.authParams, {
	        'Content-Type': 'application/x-www-form-urlencoded',
	        'Authorization': 'Basic ' + this.basicAuth
	      });
	
	      // add CORS proxy
	      url = 'https://cors-anywhere.herokuapp.com/' + url;
	      // use runscope to trace request
	      // url = url.replace('https://mbaas.selda.it', 'https://mbaas-selda-it-vsngaieqhcno.runscope.net');
	
	      return this.$http({
	        url: url,
	        method: 'POST',
	        data: this.$httpParamSerializerJQLike({ parametro: (0, _stringify2.default)(params) }),
	        headers: requestHeaders
	      });
	    }
	
	    /**
	     * Save received token and its validity in local storage
	     * @param response
	     * @private
	     */
	
	  }, {
	    key: '_saveToken',
	    value: function _saveToken(response) {
	      console.debug('Saving auth token', response.token, 'into local storage');
	      this.localStorageService.set(MBAAS_TOKEN_KEY, response.token);
	      var tokenExpiration = (0, _moment2.default)().add(parseInt(response.tokenExpire) - 2, 'minutes');
	      console.debug('Saving expiration time', tokenExpiration.format(), 'into local storage');
	      this.localStorageService.set(MBAAS_TOKEN_EXPIRE, tokenExpiration.valueOf());
	    }
	
	    /**
	     * Retrieve received token from local storage or clear it if not valid anymore
	     * @private
	     */
	
	  }, {
	    key: '_retrieveToken',
	    value: function _retrieveToken() {
	      var expiration = this.localStorageService.get(MBAAS_TOKEN_EXPIRE);
	      console.debug('Token expiration timestamp is', expiration);
	      if (expiration && (0, _moment2.default)(expiration).isAfter((0, _moment2.default)())) {
	        console.debug('Return still valid token:', this.localStorageService.get(MBAAS_TOKEN_KEY));
	        return this.localStorageService.get(MBAAS_TOKEN_KEY);
	      } else {
	        console.info('Clearing expired token', this.localStorageService.get(MBAAS_TOKEN_KEY));
	        this.localStorageService.remove(MBAAS_TOKEN_KEY);
	        this.localStorageService.remove(MBAAS_TOKEN_EXPIRE);
	        return null;
	      }
	    }
	  }]);
	  return SeldaAPIService;
	}();
	
	exports.default = SeldaAPIService;

/***/ },
/* 656 */,
/* 657 */,
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(659);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: 'E'
	};
	
	exports.default = appComponent;

/***/ },
/* 659 */
/***/ function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <!-- Global navbar for the app -->\n  <navbar></navbar>\n  <!-- Main view file -->\n  <div id=\"main-view\" ui-view></div>\n</div>\n"

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(661);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(365)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/sass-loader/index.js?sourceMap!./app.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/sass-loader/index.js?sourceMap!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(363)();
	// imports
	exports.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);", ""]);
	
	// module
	exports.push([module.id, ".app,body,html{height:100%}body,html{margin:0;padding:0}body{height:100%}@media (max-width:768px){body{background:url(" + __webpack_require__(662) + ") no-repeat fixed;background-size:100%;padding-top:55px}}@media (min-width:768px){body{background:url(" + __webpack_require__(663) + ") no-repeat fixed;background-size:100%;padding-top:82px}}.uppercase{text-transform:uppercase}#main-view{overflow-y:auto}#main-view,#main-view .container-fluid,#main-view .container-fluid .row{height:100%}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/client/app/app.scss","/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/client/app/bootstrap-customizations.scss"],"names":[],"mappings":"AAOC,eADC,WAAY,CAOb,AANA,UAIC,SACA,SACF,CAAC,KAGC,WAAY,CAMZ,yBAPF,KASI,yDACA,qBAEA,gBCiDuB,CDtC1B,CAPC,yBAhBF,KAiBI,yDACA,qBAEA,gBCwCuB,CDrC1B,CAGD,WACE,wBAAyB,CAC1B,WCsCC,eACA,CDrCF,wEAMM,WAAY,CACb","file":"app.scss","sourcesContent":["@import 'common/common';\n@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss\";\n@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_mixins.scss\";\n@import './bootstrap-customizations';\n\n.app {\n  height: 100%;\n}\n\nhtml, body {\n  height: 100%;\n  margin: 0;\n  padding: 0\n}\n\nbody {\n  height: 100%;\n  // browsers default to 16px for font-size,\n  // so setting top-level font-size to 62.5%\n  // scales 1rem to equal 10px.\n\n  // styles for mobile\n  @media (max-width: $screen-sm-min) {\n    // @include img-retina('img/bg-iphone.jpg', 'img/bg-iphone@2x.jpg', 100%, 100%);\n    background: url(./img/bg-iphone.jpg) no-repeat fixed;\n    background-size: 100%;\n    // because of fixed navbar\n    padding-top: $mobile-navbar-height;\n  }\n\n  // styles for tablet\n  @media (min-width: $screen-sm-min) {\n    background: url(./img/bg.jpg) no-repeat fixed;\n    background-size: 100%;\n    // because of fixed navbar\n    padding-top: $tablet-navbar-height;\n  }\n\n}\n\n// generic classes\n.uppercase {\n  text-transform: uppercase;\n}\n\n#main-view {\n  @include fullBody();\n\n  .container-fluid {\n    height: 100%;\n    .row {\n      height: 100%;\n    }\n  }\n}","//noinspection CssUnknownTarget\n@import url(//fonts.googleapis.com/css?family=Lato);\n\n// default color for texts\n$whitesmoke: #f5f5f5;\n\n// APP colors\n$appGrey: #B7B7B7;\n$appDarkBlue: #21242A;\n$appTransparentBlue: rgba(37, 40, 47, 0.7);\n$appAqua: #00D5C3;\n\n// Customize Bootstrap variables that get imported before the original Bootstrap variables.\n// Thus original Bootstrap variables can depend on values from here.\n$brand-primary: $appAqua;\n\n// customize app fonts and size\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n\n//** Global text color on `<body>`.\n$text-color: $whitesmoke !default;\n\n//== Typography\n//\n//## Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Lato, Helvetica, Arial, sans-serif !default;\n$font-family-serif: Georgia, \"Times New Roman\", Times, serif !default;\n//** Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`.\n$font-family-monospace: Menlo, Monaco, Consolas, \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 14px !default;\n$font-size-large: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-small: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n$font-size-h1: floor(($font-size-base * 2.6)) !default; // ~36px\n$font-size-h2: floor(($font-size-base * 2.15)) !default; // ~30px\n$font-size-h3: ceil(($font-size-base * 1.7)) !default; // ~24px\n$font-size-h4: ceil(($font-size-base * 1.25)) !default; // ~18px\n$font-size-h5: $font-size-base !default;\n$font-size-h6: ceil(($font-size-base * 0.85)) !default; // ~12px\n\n// Remove navbar backgrounds and colors\n$navbar-default-color: transparent !default;\n$navbar-default-bg: transparent !default;\n\n@mixin normalFont {\n  font-family: 'Lato', sans-serif;\n}\n\n@mixin lightFont {\n  font-family: 'Lato-Light', sans-serif;\n}\n\n@mixin normalH2 {\n  font-size: 25px;\n  @include lightFont();\n  color: $appAqua;\n}\n\n//Alloy.Globals.Typo = {\n//\th1: { fontSize: 40, fontFamily:'Lato-Light' },\n//\th1bold: { fontSize: 40, fontFamily:'Lato-Bold' },\n//\th2: { fontSize: 25, fontFamily:'Lato-Light' },\n//\th2bold: { fontSize: 25, fontFamily:'Lato-Bold' },\n//\th3: { fontSize: 18, fontFamily:'Lato-Light' },\n//\th3bold: { fontSize: 18, fontFamily:'Lato-Bold' },\n//\th4: { fontSize: 15, fontFamily:'Lato-Regular' },\n//\th4bold: { fontSize: 15, fontFamily:'Lato-Bold' },\n//\th5: { fontSize: 13, fontFamily:'Lato-Regular' },\n//\th5bold: { fontSize: 13, fontFamily:'Lato-Bold' }\n//};\n\n// navbar heights\n$tablet-navbar-height: 82px;\n$mobile-navbar-height: 55px;\n\n// Include this mixin to make an element scrollable within body and to take full body height\n@mixin fullBody {\n\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bg-iphone-c9b5044b44ae6be60f6e94b8fe700b59.jpg";

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bg-a169bb8ca9a0e8445c72ff7beef46f59.jpg";

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _office_name = __webpack_require__(665);
	
	var _office_name2 = _interopRequireDefault(_office_name);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// application services
	exports.default = _angular2.default.module('app.filters', []).filter({ officeName: _office_name2.default }).name;
	
	// app custom filters

/***/ },
/* 665 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = officeName;
	/**
	 * Format a office title
	 */
	function officeName() {
	  return function (input) {
	    var onlyLongNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    switch (input) {
	      case "Associazione Biellese Dirigenti Aziente Industriali ":
	        input = "Federmanager Biella";
	        break;
	      case "ALDAI - Associazione Lombarda Dirigenti Aziende Industriali":
	        input = "ALDAI Milano";
	        break;
	      case "Associazione Dirigenti Aziende Industriali della Provincia di Ascoli Piceno":
	        input = "Federmanager Ascoli Piceno";
	        break;
	      case "Associazione Toscana Dirigenti Aziende Industriali":
	        input = "Federmanager Toscana";
	        break;
	      case "Federmanager Associazione Dirigenti Aziende Industriali Pavia":
	        input = "Federmanager Pavia";
	        break;
	      case "Sindacato Dirigenti Aziende Industriali delle province di Ancona, Pesaro e Urbino":
	        input = "Federmanager Ancona, Pesaro e Urbino";
	        break;
	    }
	    // remove trailing federmanager string
	    return onlyLongNames ? input : input.replace(/federmanager\s+/i, '');
	  };
	}

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _address_box = __webpack_require__(667);
	
	var _address_box2 = _interopRequireDefault(_address_box);
	
	var _username = __webpack_require__(669);
	
	var _username2 = _interopRequireDefault(_username);
	
	var _image_error = __webpack_require__(670);
	
	var _image_error2 = _interopRequireDefault(_image_error);
	
	var _externalLink = __webpack_require__(408);
	
	var _externalLink2 = _interopRequireDefault(_externalLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// application services
	exports.default = _angular2.default.module('app.directives', []).directive('fmAddressBox', _address_box2.default).directive('fmUsername', _username2.default).directive('fmImageError', _image_error2.default).directive('fmExternalLink', _externalLink2.default).name;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	fmAddressBox.$inject = ["$parse"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fmAddressBox;
	/**
	 * Convert an address object into a google map link
	 */
	function fmAddressBox($parse) {
	  'ngInject';
	
	  return {
	    restrict: 'E',
	    replace: true,
	    template: __webpack_require__(668),
	    link: function link(scope, element, attrs) {
	      // parse address expression
	      var address = $parse(attrs.address)(scope);
	      // assign variables to scope
	      scope.label = attrs.label;
	      scope.location = address.recapito;
	      scope.contacts = address.contatto;
	      // function to create a maps address
	      scope.getAddressURL = function (location) {
	        var fullAddress = location.indirizzo + ', ' + location.comune;
	        return 'http://maps.google.com?q=' + encodeURI(fullAddress);
	      };
	    }
	  };
	}

/***/ },
/* 668 */
/***/ function(module, exports) {

	module.exports = "<li class=\"contacts\">\n\n    <span class=\"header\">{{label}}</span>\n    <span class=\"address\">\n        <a fm-external-link\n           ng-href=\"{{getAddressURL(location)}}\">\n            {{location.indirizzo}} -\n            {{location.cap}},\n            {{location.comune}}\n        </a>\n    </span>\n\n    <span class=\"phone\" ng-if=\"contacts.telefono\">\n        <fa name=\"phone\"></fa> Telefono\n        <a ng-href=\"tel://{{contacts.telefono}}\">\n            {{contacts.telefono}}\n        </a>\n    </span>\n\n    <span class=\"fax\" ng-if=\"contacts.fax\">\n        <fa name=\"phone\"></fa> Fax\n        <a ng-href=\"tel://{{contacts.fax}}\">\n            {{contacts.fax}}\n        </a>\n    </span>\n\n    <span class=\"email\" ng-if=\"contacts.email\">\n        <fa name=\"envelope\"></fa> Email\n        <a ng-href=\"mailto://{{contacts.email}}\">\n            {{contacts.email}}\n        </a>\n    </span>\n\n    <span class=\"info\" ng-if=\"contacts.info\">\n        <fa name=\"info\"></fa>\n        {{contacts.info}}\n    </span>\n</li>\n"

/***/ },
/* 669 */
/***/ function(module, exports) {

	'use strict';
	
	fmUsername.$inject = ["$rootScope", "UsersService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fmUsername;
	/**
	 * Show current user username and its id replacing the provided tag
	 */
	function fmUsername($rootScope, UsersService) {
	  'ngInject';
	
	  return {
	    restrict: 'E',
	    replace: true,
	    template: '<span class="username">{{user.name}} <abbr ng-if="user.id">{{user.id}}</abbr></span>',
	    link: function link(scope, element, attrs) {
	      var assignToScope = function assignToScope(user) {
	        scope.user = user ? { name: user.nome, id: user.id_user } : { name: 'Accedi' };
	      };
	      // used when storage change its value
	      var eventListener = function eventListener($event, payload) {
	        if (payload.key !== 'currentUser') return;
	        assignToScope(UsersService.currentUser());
	      };
	      // initially load user
	      assignToScope(UsersService.currentUser());
	      // configure listeners on storage events
	      $rootScope.$on('LocalStorageModule.notification.setitem', eventListener);
	      $rootScope.$on('LocalStorageModule.notification.removeitem', eventListener);
	    }
	  };
	}

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fmImageError;
	/**
	 * Replace broken images with a placeholder
	 */
	function fmImageError() {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      // replace image src with the given value
	      element.bind('error', function () {
	        var fallback = attrs.fmImageError || __webpack_require__(412);
	        if (attrs.src != fallback) {
	          attrs.$set('src', fallback);
	        }
	      });
	    }
	  };
	}

/***/ }
]);


// WEBPACK FOOTER //
// app-3b621de096542f9154a4.bundle.js